(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[737],{

/***/ 49018:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(53512);
var icon = __webpack_require__(61217);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(71993);
__webpack_require__(24774);

const TRASH = 'M8.58008 2H15.4441L16.5714 3.10257H20V5.3077H4V3.10257H7.42857L8.58008 2ZM18.8891 6.41027H5.14286V19.3538C5.14286 20.8153 6.32759 22 7.78902 22H16.243C17.7044 22 18.8891 20.8153 18.8891 19.3538V6.41027Z';
const IconTrash = lib.variant('IconTrash', icon.Icon, {
    path: TRASH,
});

exports.I = IconTrash;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 45115:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vO": () => (/* binding */ deviceType)
/* harmony export */ });
/* unused harmony exports primaryInput, supportsPassiveEvents, supportsPointerEvents, supportsTouchEvents */
// so it doesn't throw if no window or matchMedia
var w = typeof window !== 'undefined' ? window : { screen: {}, navigator: {} };
var matchMedia = (w.matchMedia || (function () { return ({ matches: false }); })).bind(w);
// passive events test
// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
var passiveOptionAccessed = false;
var options = {
    get passive() {
        return (passiveOptionAccessed = true);
    },
};
// have to set and remove a no-op listener instead of null
// (which was used previously), because Edge v15 throws an error
// when providing a null callback.
// https://github.com/rafgraph/detect-passive-events/pull/3
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function () { };
w.addEventListener && w.addEventListener('p', noop, options);
w.removeEventListener && w.removeEventListener('p', noop, false);
var supportsPassiveEvents = (/* unused pure expression or super */ null && (passiveOptionAccessed));
var supportsPointerEvents = 'PointerEvent' in w;
var onTouchStartInWindow = 'ontouchstart' in w;
var touchEventInWindow = 'TouchEvent' in w;
// onTouchStartInWindow is the old-old-legacy way to determine a touch device
// and many websites interpreted it to mean that the device is a touch only phone,
// so today browsers on a desktop/laptop computer with a touch screen (primary input mouse)
// have onTouchStartInWindow as false (to prevent from being confused with a
// touchOnly phone) even though they support the TouchEvents API, so need to check
// both onTouchStartInWindow and touchEventInWindow for TouchEvent support,
// however, some browsers (chromium) support the TouchEvents API even when running on
// a mouse only device (touchEventInWindow true, but onTouchStartInWindow false)
// so the touchEventInWindow check needs to include an coarse pointer media query
var supportsTouchEvents = onTouchStartInWindow ||
    (touchEventInWindow && matchMedia('(any-pointer: coarse)').matches);
var hasTouch = (w.navigator.maxTouchPoints || 0) > 0 || supportsTouchEvents;
// userAgent is used as a backup to correct for known device/browser bugs
// and when the browser doesn't support interaction media queries (pointer and hover)
// see https://caniuse.com/css-media-interaction
var userAgent = w.navigator.userAgent || '';
// iPads now support a mouse that can hover, however the media query interaction
// feature results always say iPads only have a coarse pointer that can't hover
// even when a mouse is connected (anyFine and anyHover are always false),
// this unfortunately indicates a touch only device but iPads should
// be classified as a hybrid device, so determine if it is an iPad
// to indicate it should be treated as a hybrid device with anyHover true
var isIPad = matchMedia('(pointer: coarse)').matches &&
    // both iPad and iPhone can "request desktop site", which sets the userAgent to Macintosh
    // so need to check both userAgents to determine if it is an iOS device
    // and screen size to separate iPad from iPhone
    /iPad|Macintosh/.test(userAgent) &&
    Math.min(w.screen.width || 0, w.screen.height || 0) >= 768;
var hasCoarsePrimaryPointer = (matchMedia('(pointer: coarse)').matches ||
    // if the pointer is not coarse and not fine then the browser doesn't support
    // interaction media queries (see https://caniuse.com/css-media-interaction)
    // so if it has onTouchStartInWindow assume it has a coarse primary pointer
    (!matchMedia('(pointer: fine)').matches && onTouchStartInWindow)) &&
    // bug in firefox (as of v81) on hybrid windows devices where the interaction media queries
    // always indicate a touch only device (only has a coarse pointer that can't hover)
    // so assume that the primary pointer is not coarse for firefox windows
    !/Windows.*Firefox/.test(userAgent);
var hasAnyHoverOrAnyFinePointer = matchMedia('(any-pointer: fine)').matches ||
    matchMedia('(any-hover: hover)').matches ||
    // iPads might have an input device that can hover, so assume it has anyHover
    isIPad ||
    // if no onTouchStartInWindow then the browser is indicating that it is not a touch only device
    // see above note for supportsTouchEvents
    !onTouchStartInWindow;
// a hybrid device is one that both hasTouch and
// any input can hover or has a fine pointer, or the primary pointer is not coarse
// if it's not a hybrid, then if it hasTouch it's touchOnly, otherwise it's mouseOnly
var deviceType = hasTouch && (hasAnyHoverOrAnyFinePointer || !hasCoarsePrimaryPointer)
    ? 'hybrid'
    : hasTouch
        ? 'touchOnly'
        : 'mouseOnly';
var primaryInput = deviceType === 'mouseOnly'
    ? 'mouse'
    : deviceType === 'touchOnly'
        ? 'touch'
        : // if the device is a hybrid, then if the primary pointer is coarse
            // assume the primaryInput is touch, otherwise assume it's mouse
            hasCoarsePrimaryPointer
                ? 'touch'
                : 'mouse';


//# sourceMappingURL=detect-it.esm.js.map


/***/ }),

/***/ 5899:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;


/***/ }),

/***/ 88987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hashClear = __webpack_require__(71519),
    hashDelete = __webpack_require__(82999),
    hashGet = __webpack_require__(76111),
    hashHas = __webpack_require__(50506),
    hashSet = __webpack_require__(80845);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 175:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var listCacheClear = __webpack_require__(2173),
    listCacheDelete = __webpack_require__(33752),
    listCacheGet = __webpack_require__(10548),
    listCacheHas = __webpack_require__(63410),
    listCacheSet = __webpack_require__(3564);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 35922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 9440:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var mapCacheClear = __webpack_require__(7140),
    mapCacheDelete = __webpack_require__(56504),
    mapCacheGet = __webpack_require__(88833),
    mapCacheHas = __webpack_require__(80953),
    mapCacheSet = __webpack_require__(70724);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 5929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    stackClear = __webpack_require__(40551),
    stackDelete = __webpack_require__(4090),
    stackGet = __webpack_require__(47694),
    stackHas = __webpack_require__(86220),
    stackSet = __webpack_require__(68958);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 92210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 93501:
/***/ ((module) => {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 79809:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseTimes = __webpack_require__(39739),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isIndex = __webpack_require__(91010),
    isTypedArray = __webpack_require__(73806);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 72340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__(30404),
    eq = __webpack_require__(42448);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 93719:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__(30404),
    eq = __webpack_require__(42448);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 62718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(42448);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 30404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__(34082);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 91348:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 91030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createBaseFor = __webpack_require__(29);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 84742:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 58939:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isMasked = __webpack_require__(90654),
    isObject = __webpack_require__(36838),
    toSource = __webpack_require__(51059);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 22882:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isLength = __webpack_require__(17216),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 52506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838),
    isPrototype = __webpack_require__(92963),
    nativeKeysIn = __webpack_require__(10814);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 97254:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    assignMergeValue = __webpack_require__(72340),
    baseFor = __webpack_require__(91030),
    baseMergeDeep = __webpack_require__(10715),
    isObject = __webpack_require__(36838),
    keysIn = __webpack_require__(37390),
    safeGet = __webpack_require__(72014);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 10715:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignMergeValue = __webpack_require__(72340),
    cloneBuffer = __webpack_require__(39767),
    cloneTypedArray = __webpack_require__(27136),
    copyArray = __webpack_require__(47165),
    initCloneObject = __webpack_require__(36404),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isArrayLikeObject = __webpack_require__(57348),
    isBuffer = __webpack_require__(61563),
    isFunction = __webpack_require__(92042),
    isObject = __webpack_require__(36838),
    isPlainObject = __webpack_require__(69143),
    isTypedArray = __webpack_require__(73806),
    safeGet = __webpack_require__(72014),
    toPlainObject = __webpack_require__(85111);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 5125:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var identity = __webpack_require__(48148),
    overRest = __webpack_require__(20323),
    setToString = __webpack_require__(71564);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 56447:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var constant = __webpack_require__(64806),
    defineProperty = __webpack_require__(34082),
    identity = __webpack_require__(48148);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 39739:
/***/ ((module) => {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 58792:
/***/ ((module) => {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 78925:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Uint8Array = __webpack_require__(92210);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 39767:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 27136:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var cloneArrayBuffer = __webpack_require__(78925);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 47165:
/***/ ((module) => {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 92434:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignValue = __webpack_require__(93719),
    baseAssignValue = __webpack_require__(30404);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 36633:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 77991:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseRest = __webpack_require__(5125),
    isIterateeCall = __webpack_require__(97616);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 29:
/***/ ((module) => {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 34082:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 67707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isKeyable = __webpack_require__(3880);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 47758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsNative = __webpack_require__(58939),
    getValue = __webpack_require__(9149);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 11389:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__(75542);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 9149:
/***/ ((module) => {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 71519:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 82999:
/***/ ((module) => {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 76111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 50506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 80845:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 36404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseCreate = __webpack_require__(91348),
    getPrototype = __webpack_require__(11389),
    isPrototype = __webpack_require__(92963);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 91010:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 97616:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(42448),
    isArrayLike = __webpack_require__(47428),
    isIndex = __webpack_require__(91010),
    isObject = __webpack_require__(36838);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 3880:
/***/ ((module) => {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 90654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var coreJsData = __webpack_require__(36633);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 92963:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 2173:
/***/ ((module) => {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 33752:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 10548:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 63410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 3564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 7140:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Hash = __webpack_require__(88987),
    ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 56504:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 88833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 80953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 70724:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 37722:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 10814:
/***/ ((module) => {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 8478:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(96476);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 75542:
/***/ ((module) => {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 20323:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var apply = __webpack_require__(93501);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 72014:
/***/ ((module) => {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 71564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseSetToString = __webpack_require__(56447),
    shortOut = __webpack_require__(15509);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 15509:
/***/ ((module) => {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 40551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 4090:
/***/ ((module) => {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 47694:
/***/ ((module) => {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 86220:
/***/ ((module) => {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 68958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922),
    MapCache = __webpack_require__(9440);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 51059:
/***/ ((module) => {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 64806:
/***/ ((module) => {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 42448:
/***/ ((module) => {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 48148:
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 30353:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsArguments = __webpack_require__(84742),
    isObjectLike = __webpack_require__(55073);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 24669:
/***/ ((module) => {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 47428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isLength = __webpack_require__(17216);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 57348:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArrayLike = __webpack_require__(47428),
    isObjectLike = __webpack_require__(55073);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 61563:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165),
    stubFalse = __webpack_require__(84193);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 92042:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObject = __webpack_require__(36838);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 17216:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 69143:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    getPrototype = __webpack_require__(11389),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 73806:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsTypedArray = __webpack_require__(22882),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 37390:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayLikeKeys = __webpack_require__(79809),
    baseKeysIn = __webpack_require__(52506),
    isArrayLike = __webpack_require__(47428);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 53954:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseMerge = __webpack_require__(97254),
    createAssigner = __webpack_require__(77991);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ 84193:
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 85111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__(92434),
    keysIn = __webpack_require__(37390);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 13708:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(40507));

var _react = _interopRequireWildcard(__webpack_require__(50959));

var _swipeJsIso = _interopRequireDefault(__webpack_require__(54817));

var _lodash = _interopRequireDefault(__webpack_require__(5899));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ReactSwipe =
/*#__PURE__*/
function (_Component) {
  _inherits(ReactSwipe, _Component);

  function ReactSwipe() {
    _classCallCheck(this, ReactSwipe);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReactSwipe).apply(this, arguments));
  }

  _createClass(ReactSwipe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.swipe = (0, _swipeJsIso.default)(this.containerEl, this.props.swipeOptions);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          childCount = _this$props.childCount,
          swipeOptions = _this$props.swipeOptions;
      var shouldUpdateSwipeInstance = prevProps.childCount !== childCount || !(0, _lodash.default)(prevProps.swipeOptions, swipeOptions);

      if (shouldUpdateSwipeInstance) {
        this.swipe.kill();
        this.swipe = (0, _swipeJsIso.default)(this.containerEl, this.props.swipeOptions);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.swipe.kill();
      this.swipe = void 0;
    }
  }, {
    key: "next",
    value: function next() {
      this.swipe.next();
    }
  }, {
    key: "prev",
    value: function prev() {
      this.swipe.prev();
    }
  }, {
    key: "slide",
    value: function slide() {
      var _this$swipe;

      (_this$swipe = this.swipe).slide.apply(_this$swipe, arguments);
    }
  }, {
    key: "getPos",
    value: function getPos() {
      return this.swipe.getPos();
    }
  }, {
    key: "getNumSlides",
    value: function getNumSlides() {
      return this.swipe.getNumSlides();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          className = _this$props2.className,
          style = _this$props2.style,
          children = _this$props2.children;
      return _react.default.createElement("div", {
        id: id,
        ref: function ref(el) {
          return _this.containerEl = el;
        },
        className: "react-swipe-container ".concat(className),
        style: style.container
      }, _react.default.createElement("div", {
        style: style.wrapper
      }, _react.default.Children.map(children, function (child) {
        if (!child) {
          return null;
        }

        var childStyle = child.props.style ? _objectSpread({}, style.child, child.props.style) : style.child;
        return _react.default.cloneElement(child, {
          style: childStyle
        });
      })));
    }
  }]);

  return ReactSwipe;
}(_react.Component);

_defineProperty(ReactSwipe, "propTypes", {
  swipeOptions: _propTypes.default.shape({
    startSlide: _propTypes.default.number,
    speed: _propTypes.default.number,
    auto: _propTypes.default.number,
    continuous: _propTypes.default.bool,
    disableScroll: _propTypes.default.bool,
    stopPropagation: _propTypes.default.bool,
    swiping: _propTypes.default.func,
    callback: _propTypes.default.func,
    transitionEnd: _propTypes.default.func
  }),
  style: _propTypes.default.shape({
    container: _propTypes.default.object,
    wrapper: _propTypes.default.object,
    child: _propTypes.default.object
  }),
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  childCount: _propTypes.default.number
});

_defineProperty(ReactSwipe, "defaultProps", {
  swipeOptions: {},
  style: {
    container: {
      overflow: 'hidden',
      visibility: 'hidden',
      position: 'relative'
    },
    wrapper: {
      overflow: 'hidden',
      position: 'relative'
    },
    child: {
      float: 'left',
      width: '100%',
      position: 'relative',
      transitionProperty: 'transform'
    }
  },
  className: '',
  childCount: 0
});

var _default = ReactSwipe;
exports["default"] = _default;
module.exports = exports["default"];


/***/ }),

/***/ 48130:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ user_personalization)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(45183);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(61041);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/checkbox/variants.js
var variants = __webpack_require__(88694);
// EXTERNAL MODULE: ./src/components/flexible-grid/index.ts + 2 modules
var flexible_grid = __webpack_require__(83628);
// EXTERNAL MODULE: ./src/areas/user/components/styles.ts
var styles = __webpack_require__(93922);
;// CONCATENATED MODULE: ./src/areas/user/components/personlization-interest.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}






var PersonalizationInterest = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(PersonalizationInterest, _PureComponent);
    var _super = _createSuper(PersonalizationInterest);
    function PersonalizationInterest(props) {
        _classCallCheck(this, PersonalizationInterest);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            categories: props.categories.map(function(category) {
                return _objectSpreadProps(_objectSpread({}, category), {
                    removed: props.settings.notInterestedIn.categories.findIndex(function(removed) {
                        return removed.id === category.id;
                    }) >= 0
                });
            })
        };
        return _this;
    }
    _createClass(PersonalizationInterest, [
        {
            key: "toggleInterest",
            value: function toggleInterest(category) {
                if (category.removed) {
                    this.addInterest(category);
                } else {
                    this.removeInterest(category);
                }
            }
        },
        {
            key: "removeInterest",
            value: function removeInterest(category) {
                this.setState(function(prevState) {
                    return {
                        categories: _toConsumableArray(prevState.categories.filter(function(c) {
                            return c.id !== category.id;
                        })).concat([
                            _objectSpreadProps(_objectSpread({}, category), {
                                removed: true
                            })
                        ])
                    };
                });
                this.props.removeInterest(category.id);
            }
        },
        {
            key: "addInterest",
            value: function addInterest(category) {
                this.setState(function(prevState) {
                    return {
                        categories: _toConsumableArray(prevState.categories.filter(function(c) {
                            return c.id !== category.id;
                        })).concat([
                            _objectSpreadProps(_objectSpread({}, category), {
                                removed: false
                            })
                        ])
                    };
                });
                this.props.addInterest(category.id);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _context = this.context, locale = _context.market.locale, t = _context.t;
                var categories = this.state.categories.sort(function(a, b) {
                    return a.name.localeCompare(b.name, locale.replace("_", "-"));
                });
                return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement("h2", null, t("account", "personalization.interests")), /*#__PURE__*/ react.createElement(flexible_grid/* Grid */.r, {
                    columnTemplate: "repeat(auto-fit, minmax(min(100%, max(300px, 100%/3)), 1fr))"
                }, categories.map(function(category) {
                    return /*#__PURE__*/ react.createElement(styles/* Row */.X2, {
                        key: category.id
                    }, /*#__PURE__*/ react.createElement("div", {
                        id: "category-".concat(category.id)
                    }, /*#__PURE__*/ react.createElement(styles/* Image */.Ee, {
                        src: category.logo,
                        alt: category.name
                    }), category.name), /*#__PURE__*/ react.createElement(variants/* Checkbox */.XZ, {
                        onChange: function() {
                            return _this.toggleInterest(category);
                        },
                        checked: !category.removed
                    }));
                })));
            }
        }
    ]);
    return PersonalizationInterest;
}(react.PureComponent);
PersonalizationInterest.propTypes = {
    categories: (prop_types_default()).array.isRequired,
    settings: prop_types_default().shape({
        notInterestedIn: prop_types_default().shape({
            categories: (prop_types_default()).array.isRequired
        }).isRequired
    }).isRequired,
    removeInterest: (prop_types_default()).func.isRequired,
    addInterest: (prop_types_default()).func.isRequired
};
PersonalizationInterest.contextType = app_context/* AppContext */.Il;
/* harmony default export */ const personlization_interest = (PersonalizationInterest);

// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(62372);
// EXTERNAL MODULE: ./src/areas/user/styles.ts
var user_styles = __webpack_require__(95858);
// EXTERNAL MODULE: ./src/areas/user/actions/personalization.js
var personalization = __webpack_require__(96283);
// EXTERNAL MODULE: ./src/areas/user/storage/personalization.js
var storage_personalization = __webpack_require__(55964);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(5148);
// EXTERNAL MODULE: ./src/hooks/use-personalized-query.ts
var use_personalized_query = __webpack_require__(13834);
// EXTERNAL MODULE: ./src/areas/user/query.graphql
var query_graphql = __webpack_require__(42409);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/areas/user/queries/usePersonalizationPageQuery.ts


function usePersonalizationPageQuery(variables) {
    return (0,use_personalized_query/* usePersonalizedQuery */.p)({
        query: (query_graphql_default()),
        queryKey: [
            "personalization"
        ],
        variables: variables
    });
}

// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(30082);
;// CONCATENATED MODULE: ./src/areas/user/personalization.js
function personalization_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function personalization_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return personalization_arrayLikeToArray(arr);
}
function personalization_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function personalization_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function personalization_toConsumableArray(arr) {
    return personalization_arrayWithoutHoles(arr) || personalization_iterableToArray(arr) || personalization_unsupportedIterableToArray(arr) || personalization_nonIterableSpread();
}
function personalization_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return personalization_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return personalization_arrayLikeToArray(o, minLen);
}















var PersonalizationPageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref = usePersonalizationPageQuery(route.variables), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, null, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data ? /*#__PURE__*/ react.createElement(PersonalizationPage, {
        data: data
    }) : null);
};
var Personalization = function(props) {
    var data = props.data, tracking = props.tracking, removeInterest = props.removeInterest, addInterest = props.addInterest;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (data.recommendation.products.fallbackToDefault || !tracking.behavior_tracking_improvement || !tracking.personalization) {
        return /*#__PURE__*/ react.createElement(react_router/* Redirect */.l_, {
            to: "/"
        });
    }
    var categories = personalization_toConsumableArray(data.recommendation.products.nodes).map(function(product) {
        return product.category;
    }).filter(function(category) {
        return category;
    }).filter(function(category, index, array) {
        return array.findIndex(function(x) {
            return x.id === category.id;
        }) === index;
    });
    var settings = (0,storage_personalization/* readPersonalizationSettings */.S)();
    return /*#__PURE__*/ react.createElement(user_styles/* Root */.fC, null, /*#__PURE__*/ react.createElement(user_styles/* BreadCrumbWrapper */.q9, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: [
            {
                title: t("account", "personalization.headline")
            }
        ]
    })), /*#__PURE__*/ react.createElement(page/* PageHeader */.mr, {
        title: t("account", "personalization.headline")
    }), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement("p", null, t("account", "personalization.description")), /*#__PURE__*/ react.createElement("p", null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "account"
    }, "personalization.privacy-settings.md"))), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(personlization_interest, {
        categories: categories,
        settings: settings,
        removeInterest: removeInterest,
        addInterest: addInterest
    })));
};
Personalization.propTypes = {
    data: prop_types_default().shape({
        recommendation: prop_types_default().shape({
            products: prop_types_default().shape({
                fallbackToDefault: (prop_types_default()).bool,
                nodes: prop_types_default().arrayOf(prop_types_default().shape({
                    id: (prop_types_default()).string,
                    name: (prop_types_default()).string,
                    logo: (prop_types_default()).string
                }))
            }),
            newReleases: prop_types_default().shape({
                nodes: prop_types_default().arrayOf(prop_types_default().shape({
                    id: (prop_types_default()).string,
                    name: (prop_types_default()).string,
                    logo: (prop_types_default()).string
                }))
            }),
            preReleases: prop_types_default().shape({
                nodes: prop_types_default().arrayOf(prop_types_default().shape({
                    id: (prop_types_default()).string,
                    name: (prop_types_default()).string,
                    logo: (prop_types_default()).string
                }))
            })
        })
    }).isRequired,
    tracking: prop_types_default().shape({
        behavior_tracking_improvement: (prop_types_default()).bool,
        personlization: (prop_types_default()).bool
    }),
    removeInterest: (prop_types_default()).func.isRequired,
    addInterest: (prop_types_default()).func.isRequired
};
Personalization.defaultProps = {
    tracking: {
        behavior_tracking_improvement: true,
        personlization: true
    }
};
var PersonalizationPage = (0,es/* connect */.$j)(function(state) {
    return {
        tracking: state.areas.user.tracking.settings
    };
}, personalization/* default */.ZP)(/*#__PURE__*/ (0,react.memo)(Personalization));
/* harmony default export */ const user_personalization = (PersonalizationPageLoader);


/***/ }),

/***/ 37979:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ data),
  "a": () => (/* reexport */ useGraphQLQuery)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/mergeWith.js
var mergeWith = __webpack_require__(53954);
var mergeWith_default = /*#__PURE__*/__webpack_require__.n(mergeWith);
// EXTERNAL MODULE: ./src/components/fetch-context.ts
var fetch_context = __webpack_require__(95698);
;// CONCATENATED MODULE: ./src/components/data/hooks.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


function useGraphQLQuery(options) {
    var query = options.query, variables = options.variables, refreshOnMount = options.refreshOnMount;
    var fetchContext = (0,react.useContext)(fetch_context/* default */.Z);
    var ref = _slicedToArray((0,react.useState)(false), 2), loading = ref[0], setLoading = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(null), 2), data = ref1[0], setData = ref1[1];
    var refresh = (0,react.useCallback)(/*#__PURE__*/ _asyncToGenerator(function() {
        var response, err;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        fetchContext.query(query, variables)
                    ];
                case 2:
                    response = _state.sent();
                    setData(response.data);
                    return [
                        3,
                        5
                    ];
                case 3:
                    err = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(err);
                    return [
                        3,
                        5
                    ];
                case 4:
                    setLoading(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchContext,
        query,
        variables
    ]);
    (0,react.useEffect)(function() {
        if (refreshOnMount) {
            refresh();
        }
    }, []);
    return {
        loading: loading,
        data: data,
        refresh: refresh
    };
}

;// CONCATENATED MODULE: ./src/components/data/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function data_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function data_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                data_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                data_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var data_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





var Data = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Data, _Component);
    var _super = _createSuper(Data);
    function Data(props) {
        _classCallCheck(this, Data);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            fetching: true,
            showLoader: true,
            data: null,
            errors: null,
            offset: 0
        };
        return _this;
    }
    _createClass(Data, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.state.fetching) {
                    return;
                }
                if (this.props.refreshKey !== prevProps.refreshKey) {
                    this.refresh();
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.run();
            }
        },
        {
            key: "run",
            value: function run() {
                var _this = this;
                return data_asyncToGenerator(function() {
                    var _props, fetchContext, query, variables, response;
                    return data_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _props = _this.props, fetchContext = _props.fetchContext, query = _props.query, variables = _props.variables;
                                _this.setState({
                                    data: null,
                                    errors: null,
                                    fetching: true,
                                    showLoader: true
                                });
                                return [
                                    4,
                                    fetchContext.query(query, variables)
                                ];
                            case 1:
                                response = _state.sent();
                                _this.setState(_objectSpreadProps(_objectSpread({}, response), {
                                    fetching: false,
                                    showLoader: false
                                }));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this = this;
                return data_asyncToGenerator(function() {
                    var _props, fetchContext, query, variables, ref, data, errors;
                    return data_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _props = _this.props, fetchContext = _props.fetchContext, query = _props.query, variables = _props.variables;
                                _this.setState({
                                    fetching: true
                                });
                                return [
                                    4,
                                    fetchContext.query(query, variables)
                                ];
                            case 1:
                                ref = _state.sent(), data = ref.data, errors = ref.errors;
                                _this.setState({
                                    data: data,
                                    errors: errors,
                                    fetching: false
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "mutation",
            value: function mutation(query, variables) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return data_asyncToGenerator(function() {
                    var _showLoader, showLoader, _refresh, refresh, ref, data, errors;
                    return data_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _showLoader = options.showLoader, showLoader = _showLoader === void 0 ? false : _showLoader, _refresh = options.refresh, refresh = _refresh === void 0 ? true : _refresh;
                                return [
                                    4,
                                    _this.props.fetchContext.query(query, variables)
                                ];
                            case 1:
                                ref = _state.sent(), data = ref.data, errors = ref.errors;
                                _this.setState({
                                    fetching: true,
                                    showLoader: showLoader
                                });
                                if (!refresh) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.refresh()
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    {
                                        data: data,
                                        errors: errors
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchMore",
            value: function fetchMore() {
                var _this = this;
                return data_asyncToGenerator(function() {
                    var _props, fetchContext, query, variables, newOffset, ref, data, errors;
                    return data_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.props.variables.limit) {
                                    throw new Error("Need limit variables in <Data> to fetch more");
                                }
                                _this.setState({
                                    fetching: true
                                });
                                _props = _this.props, fetchContext = _props.fetchContext, query = _props.query, variables = _props.variables;
                                newOffset = _this.state.offset + variables.limit;
                                return [
                                    4,
                                    fetchContext.query(query, _objectSpreadProps(_objectSpread({}, variables), {
                                        offset: newOffset
                                    }))
                                ];
                            case 1:
                                ref = _state.sent(), data = ref.data, errors = ref.errors;
                                _this.setState(function(prevState) {
                                    return {
                                        offset: newOffset,
                                        fetching: false,
                                        data: mergeWith_default()({}, prevState.data, data, function(objValue, srcValue, key) {
                                            if ((!_this.props.nodeListKey || key === _this.props.nodeListKey) && Array.isArray(objValue)) {
                                                return objValue.concat(srcValue);
                                            }
                                            return undefined;
                                        }),
                                        errors: errors
                                    };
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                if (this.state.fetching && this.state.showLoader) {
                    return this.props.renderLoader();
                }
                if (this.state.errors) {
                    return this.props.renderError();
                }
                return this.props.render(_objectSpreadProps(_objectSpread({}, this.state), {
                    refresh: function() {
                        return _this.refresh();
                    },
                    mutation: function(q, v, o) {
                        return _this.mutation(q, v, o);
                    },
                    fetchMore: function() {
                        return _this.fetchMore();
                    }
                }));
            }
        }
    ]);
    return Data;
}(react.Component);
var func = (prop_types_default()).func, string = (prop_types_default()).string, shape = (prop_types_default()).shape, object = (prop_types_default()).object;
Data.propTypes = {
    fetchContext: shape({
        query: func
    }).isRequired,
    query: string.isRequired,
    variables: object,
    renderLoader: func,
    renderError: func,
    render: func.isRequired,
    nodeListKey: string,
    refreshKey: string
};
Data.defaultProps = {
    variables: {},
    renderLoader: function() {
        return null;
    },
    renderError: function() {
        return null;
    },
    refreshKey: undefined
};
/* harmony default export */ function data(props) {
    return /*#__PURE__*/ react.createElement(fetch_context/* default.Consumer */.Z.Consumer, null, function(fetchContext) {
        return /*#__PURE__*/ react.createElement(Data, _extends({}, props, {
            fetchContext: fetchContext
        }));
    });
};


/***/ }),

/***/ 4087:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FeedbackForm": () => (/* binding */ FeedbackForm),
  "default": () => (/* binding */ feedback_form)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/form-serialize@0.7.2/node_modules/form-serialize/index.js
var form_serialize = __webpack_require__(96712);
var form_serialize_default = /*#__PURE__*/__webpack_require__.n(form_serialize);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(24084);
;// CONCATENATED MODULE: ./src/areas/feedback/types.ts
/* harmony default export */ const types = ({
    price: {
        text: "type.price",
        key: "price"
    },
    stock: {
        text: "type.stock",
        key: "stock"
    },
    wrong_prod: {
        text: "type.wrong_prod",
        key: "wrong_product"
    },
    retailer_missing: {
        text: "type.retailer_missing",
        key: "store_price_missing"
    },
    error: {
        text: "type.error",
        key: "other"
    },
    suggestion: {
        text: "type.suggestion",
        key: "other"
    }
});

// EXTERNAL MODULE: ./src/areas/feedback/actions/index.js
var actions = __webpack_require__(6416);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 7 modules
var dist_es = __webpack_require__(55703);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71309);
;// CONCATENATED MODULE: ./src/areas/feedback/components/feedback-form/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 25px;\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: 0;\n      padding-right: 40px;\n      margin-right: 40px;\n      border-right: 1px solid #bbb;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  &:not(:last-of-type) {\n    margin-bottom: 20px;\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1.4rem;\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1.4rem;\n  font-weight: 600;\n  text-align: left;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  font-weight: 600;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  text-align: left;\n  margin-top: 5px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: column;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n\n  ",
        " .pj-ui-radio {\n    font-size: 1rem;\n    margin-bottom: 5px;\n\n    label {\n      white-space: nowrap;\n    }\n  }\n\n  .pj-ui-text-input {\n    margin-bottom: 10px;\n\n    label {\n      display: block;\n      width: 100%;\n      text-align: left;\n      font-weight: 600;\n      font-size: 16px;\n      padding-bottom: 10px;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var borderRadius = base/* layout.borderRadius */.bK.borderRadius;
var Inner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Inner",
    componentId: "sc-0-0"
})(_templateObject(), borderRadius);
var Section = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Section",
    componentId: "sc-0-1"
})(_templateObject2(), base/* media.largeUp */.BC.largeUp(_templateObject1()));
var HelperText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "HelperText",
    componentId: "sc-0-2"
})(_templateObject3(), (0,dist_es/* ifProp */.fq)("bold", "600", "normal"), (0,dist_es/* ifProp */.fq)("error", "red", "inherit"));
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-3"
})(_templateObject4());
var Subtitle = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-4"
})(_templateObject5());
var Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Description",
    componentId: "sc-0-5"
})(_templateObject6());
var Form = styled_components_browser_esm["default"].form.withConfig({
    displayName: "Form",
    componentId: "sc-0-6"
})(_templateObject8(), base/* media.mediumDown */.BC.mediumDown(_templateObject7()));
var FeedbackFormSubmitButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "FeedbackFormSubmitButton",
    componentId: "sc-0-7"
})(_templateObject9(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/feedback/components/feedback-form/index.tsx








var FeedbackForm = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var feedback = (0,es/* useSelector */.v9)(function(state) {
        return state.feedback;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var emailRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (emailRef.current) {
            emailRef.current.focus();
        }
    }, []);
    var sendFeedback = function(e) {
        e.preventDefault();
        var formData = form_serialize_default()(e.target, {
            hash: true
        });
        var message = createMessage(formData);
        dispatch((0,actions/* sendRequest */.wG)(message));
    };
    var createMessage = function(formData) {
        var message = formData.message, email = formData.email, agentTypeKey = formData.agentTypeKey;
        return {
            message: message,
            uri: window.location.toString(),
            email: email,
            country_code: market.code,
            additional_info: "\n    %".concat(feedback.tag, "%\n\n    ").concat(navigator.userAgent),
            agent_type_key: agentTypeKey || "other"
        };
    };
    var feedbackOptionsList = Object.values(types);
    return /*#__PURE__*/ react.createElement(Inner, {
        "data-test": "FeedbackForm"
    }, /*#__PURE__*/ react.createElement(Title, null, t("feedback", "dialog.title")), /*#__PURE__*/ react.createElement(Description, null, t("feedback", "dialog.description")), Boolean(feedback.error) && /*#__PURE__*/ react.createElement(HelperText, {
        error: true
    }, t("feedback", "dialog.request-error")), /*#__PURE__*/ react.createElement(Form, {
        method: "post",
        onSubmit: sendFeedback
    }, feedbackOptionsList && /*#__PURE__*/ react.createElement(Section, null, /*#__PURE__*/ react.createElement(Subtitle, null, t("feedback", "dialog.subtitle")), feedbackOptionsList.map(function(type) {
        return /*#__PURE__*/ react.createElement(inputs/* Radio */.Y8, {
            key: type.text,
            id: type.text,
            name: "agentTypeKey",
            value: type.key,
            label: t("feedback", type.text),
            tabIndex: 0,
            defaultChecked: type.text === "type.suggestion"
        });
    })), /*#__PURE__*/ react.createElement(Section, null, /*#__PURE__*/ react.createElement(inputs/* TextInput */.oi, {
        required: true,
        type: "email",
        name: "email",
        label: t("feedback", "dialog.email-label"),
        helper: t("feedback", "dialog.email-helper"),
        tabIndex: 0,
        inputRef: emailRef
    }), /*#__PURE__*/ react.createElement(inputs/* TextArea */.Kx, {
        required: true,
        name: "message",
        label: t("feedback", "dialog.message-label"),
        tabIndex: 0
    }), feedback.sending && /*#__PURE__*/ react.createElement("img", {
        alt: "Loading",
        src: "https://cdn.pji.nu/rfe/g/loading.e8f390065b1f624a1f5a4a464c96b02b.gif"
    }), !feedback.sending && !feedback.thanks && /*#__PURE__*/ react.createElement(FeedbackFormSubmitButton, {
        containerProps: {
            "data-test": "FeedbackFormSubmitButton"
        },
        htmlType: "submit"
    }, t("feedback", "dialog.send-button")), feedback.thanks && /*#__PURE__*/ react.createElement(HelperText, {
        bold: true
    }, t("feedback", "dialog.thanks-for-feedback")))));
};
/* harmony default export */ const feedback_form = (FeedbackForm);


/***/ }),

/***/ 60533:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": () => (/* binding */ ProductAlertForm)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/form-serialize@0.7.2/node_modules/form-serialize/index.js
var form_serialize = __webpack_require__(96712);
var form_serialize_default = /*#__PURE__*/__webpack_require__.n(form_serialize);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/currency/market-settings.ts
var market_settings = __webpack_require__(81439);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(61041);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71309);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/checkbox/variants.js
var checkbox_variants = __webpack_require__(88694);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/trash/index.js
var trash = __webpack_require__(49018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(69346);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(69955);
// EXTERNAL MODULE: ./src/areas/account/helpers/index.ts
var helpers = __webpack_require__(56699);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(83846);
// EXTERNAL MODULE: ./src/components/render-context/ctx-link.tsx
var ctx_link = __webpack_require__(95037);
// EXTERNAL MODULE: ./src/components/review-form/components/multi-radio/index.tsx
var multi_radio = __webpack_require__(9189);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(32990);
// EXTERNAL MODULE: ./src/hooks/use-schibsted-account.ts
var use_schibsted_account = __webpack_require__(65195);
// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-form/types.ts
var types = __webpack_require__(94778);
// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-form/email-hint-styles.ts
var email_hint_styles = __webpack_require__(40407);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(24084);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/areas/product-alert/components/product-alert-form/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    .pj-ui-text-input {\n      margin-right: 0;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  .pj-ui-text-input {\n    margin-right: 1rem;\n    &--input {\n      height: 45px;\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: ",
        ";\n  align-items: center;\n  margin-top: ",
        ";\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  .pj-ui-input {\n  margin-bottom: 1rem;\n  }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  gap: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  margin-left: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}







var EmailInput = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EmailInput",
    componentId: "sc-0-0"
})(_templateObject1(), base/* media.smallOnly */.BC.smallOnly(_templateObject()), function(p) {
    return p.error && "\n    .pj-ui-input--input {\n      border-color: ".concat(p.theme.colors.negative700, ";\n    }\n  ");
});
var RatingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingWrapper",
    componentId: "sc-0-1"
})(_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var AlertForm = styled_components_browser_esm["default"].form.withConfig({
    displayName: "AlertForm",
    componentId: "sc-0-2"
})(_templateObject4(), base/* media.smallOnly */.BC.smallOnly(_templateObject3()));
var PriceBelowWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceBelowWrapper",
    componentId: "sc-0-3"
})(_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var NumberInput = (0,styled_components_browser_esm["default"])(inputs/* NumberInput */.Y2).attrs({
    variant: "rounded"
}).withConfig({
    displayName: "NumberInput",
    componentId: "sc-0-4"
})(_templateObject6());
var TextInput = (0,styled_components_browser_esm["default"])(inputs/* TextInput */.oi).attrs({
    variant: "rounded"
}).withConfig({
    displayName: "TextInput",
    componentId: "sc-0-5"
})(_templateObject7());
var PriceStepWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceStepWrapper",
    componentId: "sc-0-6"
})(_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var INPUT_WIDTH = 77;
var PriceStepInput = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceStepInput",
    componentId: "sc-0-7"
})(_templateObject9(), INPUT_WIDTH, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ShopsFilterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShopsFilterWrapper",
    componentId: "sc-0-8"
})(_templateObject10(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ShopPreferenceWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShopPreferenceWrapper",
    componentId: "sc-0-9"
})(_templateObject11(), base/* layout.measurements.spacing125 */.bK.measurements.spacing125, base/* layout.measurements.spacing125 */.bK.measurements.spacing125);
var ShopSettingsLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ShopSettingsLink",
    componentId: "sc-0-10"
})(_templateObject12(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var ShopPreferenceDropdown = (0,styled_components_browser_esm["default"])(dropdown/* Dropdown */.Lt).withConfig({
    displayName: "ShopPreferenceDropdown",
    componentId: "sc-0-11"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CheckboxNotify = (0,styled_components_browser_esm["default"])(checkbox_variants/* Checkbox */.XZ).withConfig({
    displayName: "CheckboxNotify",
    componentId: "sc-0-12"
})(_templateObject14(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var RemoveButton = (0,styled_components_browser_esm["default"])(variants.TextButton).withConfig({
    displayName: "RemoveButton",
    componentId: "sc-0-13"
})(_templateObject15(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SubmitButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SubmitButtonWrapper",
    componentId: "sc-0-14"
})(_templateObject16());
var CancelButton = (0,styled_components_browser_esm["default"])(variants.TextButton).withConfig({
    displayName: "CancelButton",
    componentId: "sc-0-15"
})(_templateObject17(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SaveAlertButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "SaveAlertButton",
    componentId: "sc-0-16"
})(_templateObject18());
var CurrencySymbol = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CurrencySymbol",
    componentId: "sc-0-17"
})(_templateObject19(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(82698);
// EXTERNAL MODULE: ./src/components/dropdown-item/index.ts + 1 modules
var dropdown_item = __webpack_require__(88669);
;// CONCATENATED MODULE: ./src/areas/product-alert/components/product-alert-form/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






















var getDefaultPriceThreshold = function(regularPrice) {
    var minimumStepValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.1, numberOfDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    return regularPrice ? (regularPrice - minimumStepValue).toFixed(numberOfDecimals) : "0";
};
var getDefaultPriceStep = function(regularPrice) {
    var minimumStepValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.1, numberOfDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var minDefaultPriceStep = minimumStepValue * 10;
    // Returns the largest value of 1% of regularPrice or minDefaultPriceStep
    return regularPrice ? Math.max(regularPrice * 0.01, minDefaultPriceStep).toFixed(numberOfDecimals) : String(minDefaultPriceStep);
};
var numberOfStoresAboveRating = function(prices, rating) {
    if (!prices) {
        return -1;
    }
    return prices.filter(function(price) {
        var ref, ref1;
        return Number(price === null || price === void 0 ? void 0 : (ref = price.store) === null || ref === void 0 ? void 0 : (ref1 = ref.userReviewSummary) === null || ref1 === void 0 ? void 0 : ref1.rating) > rating;
    }).length;
};
var ProductAlertForm = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref, ref1, ref2;
    var productAlertFormData = props.productAlertFormData, onClose = props.onClose, onCreate = props.onCreate, privacyPolicyUri = props.privacyPolicyUri, error = props.error, _isEdit = props.isEdit, isEdit = _isEdit === void 0 ? true : _isEdit, shouldAutoFocus = props.shouldAutoFocus, disabled = props.disabled, _showRemoveButton = props.showRemoveButton, showRemoveButton = _showRemoveButton === void 0 ? true : _showRemoveButton;
    var ref3 = (0,app_context/* useAppContext */.bp)(), market = ref3.market, t = ref3.t;
    var product = productAlertFormData.product;
    var userProductAlerts = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.alerts.products;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var emailInput = (0,react.useRef)(null);
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var _code = market_settings/* MarketSettings */.G[market.code], minimumStepValue = _code.minimumStepValue, numberOfDecimals = _code.numberOfDecimals;
    var ref4 = _slicedToArray((0,react.useState)(new Set()), 2), errors = ref4[0], setErrors = ref4[1];
    var ref5 = _slicedToArray((0,react.useState)(""), 2), email = ref5[0], setEmail = ref5[1];
    var ref6 = _slicedToArray((0,react.useState)(false), 2), hasSubmitted = ref6[0], setHasSubmitted = ref6[1];
    var ref7 = _slicedToArray((0,react.useState)(((product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.storeGradeThreshold) || 0) / 2), 2), chosenStoreGradeThreshold = ref7[0], setChosenStoreGradeThreshold = ref7[1];
    var ref8 = _slicedToArray((0,react.useState)(function() {
        var ref;
        return (product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.priceThreshold) ? String(product.alert.priceThreshold) : getDefaultPriceThreshold(product === null || product === void 0 ? void 0 : product.priceSummary.regular, minimumStepValue, numberOfDecimals);
    }), 2), priceThreshold = ref8[0], setPriceThreshold = ref8[1];
    var ref9 = _slicedToArray((0,react.useState)((product === null || product === void 0 ? void 0 : (ref1 = product.alert) === null || ref1 === void 0 ? void 0 : ref1.alertType) !== types/* AlertTypes.PRICE_DROPS */.d_.PRICE_DROPS), 2), onlyAlertIfInStock = ref9[0], setOnlyAlertIfInStock = ref9[1];
    var ref10 = _slicedToArray((0,react.useState)((product === null || product === void 0 ? void 0 : (ref2 = product.alert) === null || ref2 === void 0 ? void 0 : ref2.storePreference) || types/* ShopPreference.NONE */.lc.NONE), 2), shopPreference = ref10[0], setShopPreference = ref10[1];
    // Default to true
    var ref11 = _slicedToArray((0,react.useState)((product === null || product === void 0 ? void 0 : product.alert) ? !!product.alert.priceStep : true), 2), priceStepCheckbox = ref11[0], setPriceStepCheckbox = ref11[1];
    var ref12 = _slicedToArray((0,react.useState)(function() {
        var ref;
        if (product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.priceStep) {
            return String(product.alert.priceStep);
        }
        return getDefaultPriceStep(product === null || product === void 0 ? void 0 : product.priceSummary.regular, minimumStepValue, numberOfDecimals);
    }), 2), priceStep = ref12[0], setPriceStep = ref12[1];
    (0,react.useEffect)(function() {
        if (emailInput.current && shouldAutoFocus) {
            emailInput.current.focus();
        }
        return function cleanup() {
            dispatch((0,actions_alert/* removeAlertError */.TI)(undefined));
        };
    }, [
        dispatch,
        shouldAutoFocus
    ]);
    var clearErrors = function() {
        return setErrors(new Set());
    };
    var addError = function(newError) {
        setErrors(function(prevErrors) {
            var draftErrors = new Set(prevErrors);
            return draftErrors.add(newError);
        });
    };
    var removeError = function(errorToRemove) {
        setErrors(function(prevErrors) {
            var draftErrors = new Set(prevErrors);
            draftErrors.delete(errorToRemove);
            return draftErrors;
        });
    };
    (0,react.useEffect)(function() {
        if (!error) {
            return;
        }
        switch(error){
            case types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID:
            case types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE:
                {
                    addError(error);
                    break;
                }
            default:
                {
                    addError(types/* Errors.ERROR_UNKNOWN */.D1.ERROR_UNKNOWN);
                }
        }
    }, [
        error
    ]);
    var handlePriceThresholdChange = function(event) {
        setPriceThreshold(event.target.value);
        if (!event.target.value || Number(event.target.value) < 0) {
            addError(types/* Errors.ERROR_THRESHOLD_TOO_LOW */.D1.ERROR_THRESHOLD_TOO_LOW);
        } else {
            removeError(types/* Errors.ERROR_THRESHOLD_TOO_LOW */.D1.ERROR_THRESHOLD_TOO_LOW);
        }
    };
    var handlePriceStepChange = function(event) {
        setPriceStep(event.target.value);
    };
    var handleOnlyAlertIfInStockChange = function() {
        return setOnlyAlertIfInStock(function(state) {
            return !state;
        });
    };
    var handlePriceStepCheckboxChange = function() {
        return setPriceStepCheckbox(function(state) {
            return !state;
        });
    };
    var handleEmailChange = function(event) {
        /* The error state is duplicated, between Redux and local state. This is due
    to the fact that we are using sagas to make the create alert request.
    The problem, apart from duplication, is that the error messages outlive the
    form since they are stored in redux. So the error handling in this form
    needs to be improved/simplified. But for now the code below is required to
    fix the issue with the email error messages not disappearing even though the
    user corrects the email.
    */ if ((0,helpers/* isValidEmail */.vV)(event.target.value)) {
            removeError(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
        } else if (hasSubmitted) {
            addError(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
        }
        dispatch((0,actions_alert/* removeAlertError */.TI)(undefined));
        removeError(types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE);
        setEmail(event.target.value);
    };
    var saveAlert = (0,react.useCallback)(function(event) {
        event.preventDefault();
        setHasSubmitted(true);
        var ref = form_serialize_default()(event.target, {
            hash: true
        }), _rating = ref.rating, rating = _rating === void 0 ? 0 : _rating;
        var userAlert = userProductAlerts.find(function(alert) {
            return alert.productId === (product === null || product === void 0 ? void 0 : product.id);
        });
        if (!product) {
            return;
        }
        clearErrors();
        if (!isAuthenticated && !(0,helpers/* isValidEmail */.vV)(email)) {
            addError(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
            if (shouldAutoFocus && emailInput.current) {
                emailInput.current.focus();
                emailInput.current.select();
            }
            return;
        }
        if (Number(priceThreshold) < 0 || Number(priceStep) < 0) {
            return;
        }
        var graphQLAlert = {
            type: onlyAlertIfInStock ? types/* AlertTypes.IN_STOCK_PRICE_DROPS */.d_.IN_STOCK_PRICE_DROPS : types/* AlertTypes.PRICE_DROPS */.d_.PRICE_DROPS,
            priceThreshold: Number(priceThreshold)
        };
        var priceStepValue = priceStepCheckbox ? Number(priceStep) : undefined;
        onCreate(_objectSpread({
            alertId: userAlert && userAlert.alertId,
            productId: product.id,
            email: !isAuthenticated ? email : undefined,
            priceStep: priceStepValue,
            storePreference: shopPreference === types/* ShopPreference.NONE */.lc.NONE ? undefined : shopPreference,
            storeGradeThreshold: rating ? Number(rating) * 2 : undefined
        }, graphQLAlert));
    }, [
        email,
        onCreate,
        onlyAlertIfInStock,
        priceStep,
        priceStepCheckbox,
        priceThreshold,
        shopPreference,
        product,
        shouldAutoFocus,
        userProductAlerts,
        isAuthenticated
    ]);
    var removeAlert = function() {
        var userAlert = userProductAlerts.find(function(alert) {
            return alert.productId === (product === null || product === void 0 ? void 0 : product.id);
        });
        if (!(userAlert === null || userAlert === void 0 ? void 0 : userAlert.alertId)) return;
        dispatch((0,actions_alert/* removeAlertRequest */.s$)(userAlert.alertId, product === null || product === void 0 ? void 0 : product.id));
        if (onClose) onClose();
    };
    var shopPreferenceOptions = [
        {
            name: t("alerts", "alerts.shop-preference-none"),
            value: types/* ShopPreference.NONE */.lc.NONE
        },
        {
            name: t("alerts", "alerts.shop-preference-exclude-disliked"),
            value: types/* ShopPreference.EXCLUDE_DISLIKED */.lc.EXCLUDE_DISLIKED
        },
        {
            name: t("alerts", "alerts.shop-preference-liked"),
            value: types/* ShopPreference.LIKED */.lc.LIKED
        }
    ];
    var marketCurrencySymbol = market_settings/* MarketSettings */.G[market.code].symbol;
    var renderTypeOptions = function() {
        var ref, ref1, ref2;
        return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(PriceBelowWrapper, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
            emphasis: text_variants.FontEmphasis.MEDIUM
        }, t("alerts", "type.price-below")), /*#__PURE__*/ react.createElement(NumberInput, {
            name: "priceThreshold",
            ariaLabel: t("alerts", "alert-form.price-limit"),
            warning: errors.has(types/* Errors.ERROR_THRESHOLD_TOO_LOW */.D1.ERROR_THRESHOLD_TOO_LOW),
            value: priceThreshold,
            onChange: handlePriceThresholdChange,
            step: minimumStepValue,
            max: (product === null || product === void 0 ? void 0 : product.priceSummary.regular) ? Number((product.priceSummary.regular - minimumStepValue).toFixed(numberOfDecimals)) : undefined,
            min: 0,
            "data-testid": "price-threshold-number-input"
        })), /*#__PURE__*/ react.createElement(PriceStepWrapper, null, /*#__PURE__*/ react.createElement(checkbox_variants/* CheckboxSwitch */.K_, {
            text: t("alerts", "alert-form.price-step-checkbox"),
            onChange: handlePriceStepCheckboxChange,
            checked: priceStepCheckbox
        }), /*#__PURE__*/ react.createElement(PriceStepInput, null, /*#__PURE__*/ react.createElement(NumberInput, {
            name: "priceStep",
            ariaLabel: t("alerts", "alert-form.price-interval"),
            "data-testid": "price-step-number-input",
            disabled: !priceStepCheckbox,
            warning: Number(priceStep) < 0,
            value: priceStep,
            onChange: handlePriceStepChange,
            step: minimumStepValue,
            max: (product === null || product === void 0 ? void 0 : product.priceSummary.regular) ? Number((product.priceSummary.regular - minimumStepValue).toFixed(numberOfDecimals)) : undefined,
            min: 0
        })), /*#__PURE__*/ react.createElement(CurrencySymbol, null, marketCurrencySymbol))), /*#__PURE__*/ react.createElement(CheckboxNotify, {
            name: "onlyAlertIfInStock",
            checked: onlyAlertIfInStock,
            text: t("alerts", "alert-form.only-notify-in-stock"),
            onChange: handleOnlyAlertIfInStockChange
        }), /*#__PURE__*/ react.createElement(ShopsFilterWrapper, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
            emphasis: text_variants.FontEmphasis.MEDIUM
        }, t("alerts", "alert-form.shops-with-higher-rating")), /*#__PURE__*/ react.createElement(RatingWrapper, null, /*#__PURE__*/ react.createElement(multi_radio/* default */.ZP, {
            currentValue: (product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.storeGradeThreshold) ? product.alert.storeGradeThreshold / 2 : null,
            disabledOptions: [
                5
            ],
            name: "rating",
            onClick: function(e) {
                setChosenStoreGradeThreshold(Number(e.target.value));
            },
            options: [
                1,
                2,
                3,
                4,
                5
            ],
            optionValues: [
                t("reviews", "rating.terrible"),
                t("reviews", "rating.bad"),
                t("reviews", "rating.ok"),
                t("reviews", "rating.good"),
                t("reviews", "rating.excellent")
            ],
            required: true,
            size: "small",
            variant: multi_radio/* Variants.rate */.tr.rate
        }), /*#__PURE__*/ react.createElement("p", null, (product === null || product === void 0 ? void 0 : product.prices) ? t("alerts", "alert-form.n-stores", {
            n: numberOfStoresAboveRating(product === null || product === void 0 ? void 0 : (ref1 = product.prices) === null || ref1 === void 0 ? void 0 : ref1.nodes, chosenStoreGradeThreshold)
        }) : null)), isAuthenticated && /*#__PURE__*/ react.createElement(ShopPreferenceWrapper, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
            emphasis: text_variants.FontEmphasis.MEDIUM
        }, t("alerts", "alert-form.filter-shops")), /*#__PURE__*/ react.createElement(ShopPreferenceDropdown, {
            closeOnItemClick: true
        }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
            showActiveIcon: true,
            type: variants.ButtonType.TEXT,
            disabled: !isAuthenticated,
            containerProps: {
                "data-testid": "ShopPreferenceSelector"
            }
        }, (ref2 = shopPreferenceOptions.find(function(row) {
            return row.value === shopPreference;
        })) === null || ref2 === void 0 ? void 0 : ref2.name), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
            placement: ui/* Direction.Up */.Nm.Up
        }, shopPreferenceOptions.map(function(option) {
            return /*#__PURE__*/ react.createElement(dropdown_item/* DropdownItem */.h, {
                "data-test": "DropdownOption",
                containerProps: {
                    "data-testid": option.value
                },
                key: option.value,
                disabled: shopPreference === option.value,
                onClick: function() {
                    return setShopPreference(option.value);
                }
            }, option.name);
        }))), /*#__PURE__*/ react.createElement(ShopSettingsLink, {
            to: "/account/profile/shop-preference"
        }, t("alerts", "alert-form.shops-settings")))));
    };
    var login = (0,use_schibsted_account/* useSchibstedAccount */.F)().login;
    return /*#__PURE__*/ react.createElement(AlertForm, {
        method: "post",
        onSubmit: saveAlert,
        noValidate: true
    }, renderTypeOptions(), /*#__PURE__*/ react.createElement(EmailInput, {
        error: errors.has(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID)
    }, !isAuthenticated && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(TextInput, {
        type: "email",
        name: "email",
        inputRef: emailInput,
        defaultValue: email,
        onChange: handleEmailChange,
        placeholder: t("alerts", "alert-form.email-placeholder"),
        tabIndex: 0,
        autoFocus: shouldAutoFocus,
        // Do not send this element to CUX (cux.io)
        "data-cux-exclude": true
    }), /*#__PURE__*/ react.createElement(email_hint_styles/* EmailHint */.T, {
        error: true,
        visible: errors.has(types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE)
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.email-in-use-error"), "\xa0", /*#__PURE__*/ react.createElement(ctx_link/* CtxLink */.b, {
        to: "/login",
        onClick: function(e) {
            e.preventDefault();
            login();
        }
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.login-error"))), /*#__PURE__*/ react.createElement(email_hint_styles/* EmailHint */.T, {
        error: true,
        visible: errors.has(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID)
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.invalid-email-error")), /*#__PURE__*/ react.createElement(email_hint_styles/* EmailHint */.T, {
        error: true,
        visible: errors.has(types/* Errors.ERROR_UNKNOWN */.D1.ERROR_UNKNOWN)
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.unknown-error")), privacyPolicyUri && /*#__PURE__*/ react.createElement(email_hint_styles/* EmailHint */.T, {
        visible: true,
        discreetLink: true
    }, /*#__PURE__*/ react.createElement(ctx_link/* CtxLink */.b, {
        to: privacyPolicyUri
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "alert.how-your-email-is-used"))))), isEdit && showRemoveButton && /*#__PURE__*/ react.createElement(RemoveButton, {
        onClick: removeAlert
    }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(trash/* IconTrash */.I, null)), /*#__PURE__*/ react.createElement(variants.ButtonText, null, t("product", "alert.delete-button"))), /*#__PURE__*/ react.createElement(SubmitButtonWrapper, null, isEdit && onClose && product && /*#__PURE__*/ react.createElement(CancelButton, {
        onClick: onClose
    }, t("alerts", "alert-form.cancel-button")), /*#__PURE__*/ react.createElement(SaveAlertButton, {
        disabled: disabled || errors.size > 0,
        containerProps: {
            "data-testid": "CreateAlertButton",
            "data-test": "CreateAlertButton"
        },
        htmlType: "submit",
        fullWidth: true
    }, t("alerts", "alert-form.create-button"))));
});


/***/ }),

/***/ 22610:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ product_alert_modal_content)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(65208);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(69346);
// EXTERNAL MODULE: ./src/components/data/index.js + 1 modules
var data = __webpack_require__(37979);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(30082);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(83846);
// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-form/index.tsx + 1 modules
var product_alert_form = __webpack_require__(60533);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(9160);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(49763);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/areas/product-alert/components/product-alert-info/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  column-gap: ",
        ";\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  margin: 0 1rem;\n\n  h2 {\n    font-size: 1rem;\n    font-weight: normal;\n    margin-bottom: 0.25rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ProductAlertInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductAlertInfo",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ProductInfoName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductInfoName",
    componentId: "sc-0-1"
})(_templateObject1());
var IMAGE_MAX_WIDTH = 64;
var ProductInfoImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "ProductInfoImage",
    componentId: "sc-0-2"
})(_templateObject2(), IMAGE_MAX_WIDTH);

;// CONCATENATED MODULE: ./src/areas/product-alert/components/product-alert-info/index.tsx






var product_alert_info_ProductAlertInfo = function(props) {
    var ref, ref1, ref2;
    var productAlertFormData = props.productAlertFormData;
    var product = productAlertFormData.product;
    return /*#__PURE__*/ react.createElement(ProductAlertInfo, null, (product === null || product === void 0 ? void 0 : product.media.first) && /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: product.pathName
    }, /*#__PURE__*/ react.createElement(ProductInfoImage, {
        src: product.media.first,
        alt: product.name
    })), /*#__PURE__*/ react.createElement(ProductInfoName, null, /*#__PURE__*/ react.createElement(text_variants.H3Text, null, (product === null || product === void 0 ? void 0 : product.pathName) && /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: product.pathName
    }, product === null || product === void 0 ? void 0 : product.name), !(product === null || product === void 0 ? void 0 : product.pathName) && /*#__PURE__*/ react.createElement("span", null, product === null || product === void 0 ? void 0 : product.name)), /*#__PURE__*/ react.createElement(rating/* default */.Z, {
        hide: (product === null || product === void 0 ? void 0 : (ref = product.aggregatedRatingSummary) === null || ref === void 0 ? void 0 : ref.summary.rating.count) === 0 || (product === null || product === void 0 ? void 0 : product.userReviewSummary.count) === 0,
        count: (product === null || product === void 0 ? void 0 : (ref1 = product.aggregatedRatingSummary) === null || ref1 === void 0 ? void 0 : ref1.summary.rating.count) || (product === null || product === void 0 ? void 0 : product.userReviewSummary.count),
        rate: (product === null || product === void 0 ? void 0 : (ref2 = product.aggregatedRatingSummary) === null || ref2 === void 0 ? void 0 : ref2.summary.rating.score) || (product === null || product === void 0 ? void 0 : product.userReviewSummary.rating),
        showCounter: true,
        showRate: true
    })), !!(product === null || product === void 0 ? void 0 : product.priceSummary.regular) && /*#__PURE__*/ react.createElement(text_variants.TitleMediumText, null, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: product === null || product === void 0 ? void 0 : product.priceSummary.regular
    })));
};

;// CONCATENATED MODULE: ./src/areas/product-alert/components/create-alert/index.tsx





var CreateAlert = function(props) {
    var productAlertFormData = props.productAlertFormData, privacyPolicyUri = props.privacyPolicyUri, _isEdit = props.isEdit, isEdit = _isEdit === void 0 ? false : _isEdit, onClose = props.onClose, onCreate = props.onCreate;
    var dispatch = (0,es/* useDispatch */.I0)();
    var onCreateHandler = function(productAlert) {
        return dispatch((0,actions_alert/* createAlertRequest */.$b)(productAlert, onCreate || onClose));
    };
    var sending = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.productAlert.sending;
    });
    var error = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.productAlert.error;
    });
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(product_alert_info_ProductAlertInfo, {
        productAlertFormData: productAlertFormData
    }), /*#__PURE__*/ react.createElement(product_alert_form/* ProductAlertForm */.u, {
        productAlertFormData: productAlertFormData,
        disabled: sending,
        error: error,
        onClose: onClose,
        onCreate: onCreateHandler,
        privacyPolicyUri: privacyPolicyUri,
        isEdit: isEdit,
        shouldAutoFocus: true
    }));
};

// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-modal-content/productAlertFormQuery.graphql
var productAlertFormQuery_graphql = __webpack_require__(57070);
var productAlertFormQuery_graphql_default = /*#__PURE__*/__webpack_require__.n(productAlertFormQuery_graphql);
// EXTERNAL MODULE: ./src/components/error-message/index.tsx + 1 modules
var error_message = __webpack_require__(40314);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
;// CONCATENATED MODULE: ./src/areas/product-alert/components/product-alert-modal-content/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(styles_templateObject());
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/product-alert/components/product-alert-modal-content/index.tsx










var ProductAlertModalContent = function(props) {
    var className = props.className, productId = props.productId, hideModal = props.hideModal, privacyPolicyUri = props.privacyPolicyUri;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var renderError = function() {
        return /*#__PURE__*/ react.createElement(error_message/* default */.Z, null);
    };
    var renderLoader = function() {
        return /*#__PURE__*/ react.createElement(loader/* default */.Z, {
            fadeIn: true
        });
    };
    var variables = {
        id: productId
    };
    var renderCallback = react.useCallback(function(param) {
        var data = param.data;
        var ref, ref1;
        var isEdit = Boolean(data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : (ref1 = ref.alert) === null || ref1 === void 0 ? void 0 : ref1.id);
        return /*#__PURE__*/ react.createElement(Wrapper, {
            className: className
        }, /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement(text_variants.TitleMediumText, null, isEdit ? t("product", "alert.title-edit") : t("product", "alert.title"))), /*#__PURE__*/ react.createElement(variants.Column, {
            gap: 1
        }, /*#__PURE__*/ react.createElement(CreateAlert, {
            productAlertFormData: data,
            privacyPolicyUri: privacyPolicyUri,
            isEdit: isEdit,
            onClose: hideModal
        })));
    }, [
        hideModal,
        privacyPolicyUri,
        t
    ]);
    return /*#__PURE__*/ react.createElement(data/* default */.Z, {
        query: (productAlertFormQuery_graphql_default()),
        renderLoader: renderLoader,
        variables: variables,
        render: renderCallback,
        renderError: renderError
    });
};
/* harmony default export */ const product_alert_modal_content = (ProductAlertModalContent);


/***/ }),

/***/ 65436:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95939);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71993);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18026);
/* harmony import */ var _product_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16130);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67254);
/* harmony import */ var src_components_data__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37979);
/* harmony import */ var src_components_placeholder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87402);
/* harmony import */ var src_components_recommendations_recommendations_query_graphql__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57053);
/* harmony import */ var src_components_recommendations_recommendations_query_graphql__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(src_components_recommendations_recommendations_query_graphql__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48458);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56829);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28510);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var OtherAlsoVisitedCarousel = function() {
    var ref;
    var ref1 = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_3__/* .useAppContext */ .bp)(), market = ref1.market, t = ref1.t;
    var product = (0,_product_context__WEBPACK_IMPORTED_MODULE_4__/* .useProductContext */ .$h)().product;
    var user = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.user;
    });
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_data__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        render: function(response) {
            var recommendations = response.data.recommendations;
            if (!(recommendations === null || recommendations === void 0 ? void 0 : recommendations.length)) return null;
            var recommendedProducts = recommendations.flatMap(function(rec) {
                return rec.recommendations.map(function(p) {
                    return p.product;
                });
            }).filter(function(isTruthy) {
                return isTruthy;
            }).map(function(p) {
                var ref, ref1;
                return {
                    aggregatedRating: p.aggregatedRating,
                    category: p.category,
                    classicFullPath: p.uri,
                    id: p.id,
                    imageUrl: (ref = p.media) === null || ref === void 0 ? void 0 : ref.first,
                    name: p.name,
                    // @ts-expect-error Should get fixed (in other MR) with the new resolver not to also include the domain etc.
                    pathName: p.pathName,
                    price: (ref1 = p.price) === null || ref1 === void 0 ? void 0 : ref1.regular,
                    type: recommendations[0].model,
                    url: p.webUri,
                    userReviewSummary: p.userReviews,
                    isExpertTopRated: p.isExpertTopRated
                };
            });
            if (!recommendedProducts.length) return null;
            var carouselType = recommendations[0].model;
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(___WEBPACK_IMPORTED_MODULE_5__/* .CarouselProducts */ .S, {
                carouselType: carouselType,
                products: (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .mapCarouselProducts */ .b)(recommendedProducts) || [],
                title: t("product", "recommendations.others-visited")
            });
        },
        renderLoader: function() {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPlaceholder, {
                amount: 4,
                height: ___WEBPACK_IMPORTED_MODULE_10__/* .CAROUSEL_HEIGHT */ .A,
                rows: 1
            });
        },
        query: (src_components_recommendations_recommendations_query_graphql__WEBPACK_IMPORTED_MODULE_8___default()),
        variables: {
            id: product.id,
            marketCode: market.code,
            personalizationClientId: user === null || user === void 0 ? void 0 : (ref = user.personalization) === null || ref === void 0 ? void 0 : ref.clientId,
            recommendationsContextId: _constants__WEBPACK_IMPORTED_MODULE_9__/* .PRODUCT_CONTEXT_ID */ .S
        }
    });
};
var StyledPlaceholder = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(src_components_placeholder__WEBPACK_IMPORTED_MODULE_7__/* .Placeholder */ .V).withConfig({
    displayName: "StyledPlaceholder",
    componentId: "sc-0-0"
})(_templateObject(), ___WEBPACK_IMPORTED_MODULE_10__/* .CAROUSEL_HEIGHT */ .A);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OtherAlsoVisitedCarousel);


/***/ }),

/***/ 75120:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ report_button)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(66275);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/report-modal/index.tsx
var report_modal = __webpack_require__(5884);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71309);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row-context.tsx
var price_row_context = __webpack_require__(70264);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/types.ts
var types = __webpack_require__(3382);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/report-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  animation: ",
        " 250ms ease-in-out 1;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n  cursor: pointer;\n  white-space: nowrap;\n  font-weight: 600;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      align-items: center;\n      flex-direction: row;\n      justify-content: center;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1 0 auto;\n  flex-direction: column;\n  align-items: start;\n  color: ",
        ";\n  font-size: ",
        ";\n  column-gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      margin-top: ",
        ";\n      margin-bottom: ",
        ";\n      border-radius: 8px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    background: ",
        ";\n    padding: 0 ",
        ";\n    padding: ",
        ";\n    padding-left: ",
        ";\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var fadeIn = (0,styled_components_browser_esm.keyframes)(_templateObject());
var ReportOverlay = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReportOverlay",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.theme.text.secondary;
}, fadeIn);
var ToggleButtons = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ToggleButtons",
    componentId: "sc-0-1"
})(_templateObject2(), function(p) {
    return p.theme.text.negative;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var PromptTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PromptTitle",
    componentId: "sc-0-2"
})(_templateObject4(), function(p) {
    return p.theme.text.tertiary;
}, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(props) {
    return props.$viewSize !== undefined && props.$viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && (0,styled_components_browser_esm.css)(_templateObject3());
});
var StyledReportButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledReportButton",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject7(), props.theme.text.secondary, props.theme.colors.base100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, !props.$isAlternative && (0,styled_components_browser_esm.css)(_templateObject5(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050), props.$viewSize !== undefined && props.$viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && (0,styled_components_browser_esm.css)(_templateObject6()));
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/report-button/report-button.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var ReportButton = function(props) {
    var ref;
    var _isAlternative = props.isAlternative, isAlternative = _isAlternative === void 0 ? false : _isAlternative, onClose = props.onClose, priceValue = props.priceValue, stockStatus = props.stockStatus, priceId = props.priceId, productName = props.productName;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref1 = (0,price_row_context/* usePriceRowContext */.m)(), _offer = ref1.offer, featured = _offer.featured, store = _offer.store, product = ref1.product, viewSize = ref1.viewSize;
    var ref2 = _slicedToArray((0,react.useState)(false), 2), modalIsOpen = ref2[0], setModalIsOpen = ref2[1];
    var handleOnClose = (0,react.useCallback)(function(e) {
        e.preventDefault();
        e.stopPropagation();
        onClose();
    }, [
        onClose
    ]);
    var openModal = (0,react.useCallback)(function(e) {
        // Stops the PriceRow link and onClick from firing
        e.preventDefault();
        e.stopPropagation();
        setModalIsOpen(true);
    }, [
        setModalIsOpen
    ]);
    var closeModal = (0,react.useCallback)(function() {
        return setModalIsOpen(false);
    }, [
        setModalIsOpen
    ]);
    return /*#__PURE__*/ react.createElement(StyledReportButton, {
        $isAlternative: isAlternative,
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(report_modal/* ReportModal */.y, {
        isOpen: modalIsOpen,
        closeModal: closeModal,
        onClose: onClose,
        priceId: priceId,
        priceValue: priceValue,
        productName: productName,
        stockStatus: stockStatus,
        store: store,
        isFeatured: featured,
        productImage: (ref = product.media) === null || ref === void 0 ? void 0 : ref.first
    }), /*#__PURE__*/ react.createElement(ReportOverlay, null, /*#__PURE__*/ react.createElement(PromptTitle, {
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement("span", null, t("feedback", "dialog.prompt-title")), /*#__PURE__*/ react.createElement(ToggleButtons, {
        type: "button",
        onClick: openModal
    }, t("feedback", "dialog.prompt-button"))), /*#__PURE__*/ react.createElement(variants.IconButton, {
        onClick: handleOnClose,
        size: variants.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(icon_close.IconClose, null))));
};
/* harmony default export */ const report_button = (ReportButton);


/***/ }),

/***/ 37852:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ report_modal)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(19247);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/check-filled/index.js
var check_filled = __webpack_require__(26278);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close-filled/index.js
var close_filled = __webpack_require__(20746);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(56627);
// EXTERNAL MODULE: ./src/areas/feedback/actions/index.js
var actions = __webpack_require__(6416);
// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(11124);
// EXTERNAL MODULE: ./src/components/modal/index.tsx
var modal = __webpack_require__(58203);
// EXTERNAL MODULE: ./src/components/static-intercom/index.tsx + 1 modules
var static_intercom = __webpack_require__(43344);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/report-modal/types.ts
var ReportType;
(function(ReportType) {
    ReportType["WrongPrice"] = "price";
    ReportType["WrongStockStatus"] = "stock";
    ReportType["WrongProduct"] = "wrong_product";
})(ReportType || (ReportType = {}));

// EXTERNAL MODULE: ./src/areas/store/constants.ts
var constants = __webpack_require__(70320);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(47477);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(87044);
// EXTERNAL MODULE: ./src/components/stock-status/index.tsx + 1 modules
var stock_status = __webpack_require__(74233);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71309);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/report-modal/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1 0 auto;\n  flex-direction: column;\n  max-width: 100%;\n  align-items: center;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: ",
        ";\n\n  > span {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n\n  &:not(:last-of-type) {\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n\n  svg {\n    margin-right: 10px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n      font-size: ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  text-align: center;\n  max-width: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: ",
        ";\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  svg {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}






var sharedMarginStyles = (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CardMargin = "23px";
var productImageSize = "48px";
var buttonMaxWidth = "210px";
var priceLabelFontSize = "20px";
var submitMessageHeight = "150px";
var reportDescriptionWidth = "450px";
var StyledContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContent",
    componentId: "sc-0-0"
})(_templateObject1());
var StyledCard = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledCard",
    componentId: "sc-0-1"
})(_templateObject2(), CardMargin);
var ButtonStyles = (0,styled_components_browser_esm.css)(_templateObject3(), buttonMaxWidth);
var StyledButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "StyledButton",
    componentId: "sc-0-2"
})(_templateObject4(), ButtonStyles);
var StyledFeedbackButton = (0,styled_components_browser_esm["default"])(variants.OutlinedButton).withConfig({
    displayName: "StyledFeedbackButton",
    componentId: "sc-0-3"
})(_templateObject5(), ButtonStyles);
var StyledTitle = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-4"
})(_templateObject6());
var StyledProductImage = (0,styled_components_browser_esm["default"])(product_image/* ProductImage */.q).withConfig({
    displayName: "StyledProductImage",
    componentId: "sc-0-5"
})(_templateObject7(), productImageSize, sharedMarginStyles);
var StyledProductName = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledProductName",
    componentId: "sc-0-6"
})(_templateObject8(), sharedMarginStyles);
var StyledReportDescription = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledReportDescription",
    componentId: "sc-0-7"
})(_templateObject10(), sharedMarginStyles, reportDescriptionWidth, function(props) {
    return props.$thin && (0,styled_components_browser_esm.css)(_templateObject9(), function(p) {
        return p.theme.text.tertiary;
    }, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
});
var StyledPriceLabel = (0,styled_components_browser_esm["default"])(price_label/* PriceLabel */.l).withConfig({
    displayName: "StyledPriceLabel",
    componentId: "sc-0-8"
})(_templateObject11(), sharedMarginStyles, priceLabelFontSize);
var StyledSubmitMessage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSubmitMessage",
    componentId: "sc-0-9"
})(_templateObject12(), submitMessageHeight);
var StyledMessage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledMessage",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledStockStatus = (0,styled_components_browser_esm["default"])(stock_status/* StockStatus */.B).withConfig({
    displayName: "StyledStockStatus",
    componentId: "sc-0-11"
})(_templateObject14(), sharedMarginStyles);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/report-modal/report-modal.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};














var ReportModal = function(props) {
    var closeModal = props.closeModal, isOpen = props.isOpen, onClose = props.onClose, priceId = props.priceId, priceValue = props.priceValue, productName = props.productName, stockStatus = props.stockStatus, isFeatured = props.isFeatured, productImage = props.productImage, store = props.store;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), market = ref.market, t = ref.t;
    var ref1 = _slicedToArray((0,react.useState)(false), 2), error = ref1[0], setError = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), success = ref2[0], setSuccess = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)(false), 2), sending = ref3[0], setSending = ref3[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var submitted = success || error || sending;
    var postFeedback = function() {
        var _ref = _asyncToGenerator(function(data) {
            var res;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,requests/* postFeedback */.qr)(data)
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.data.feedback.success === true) {
                            return [
                                2,
                                res
                            ];
                        }
                        if (res.errors) {
                            throw new Error("Error creating report on price: ".concat(JSON.stringify(res.errors)));
                        }
                        throw new Error("Error creating report on price.");
                }
            });
        });
        return function postFeedback(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var onReport = (0,react.useCallback)(function(e, type) {
        if (false) {}
        // Stops click out action event
        e.preventDefault();
        e.stopPropagation();
        var message = "Error report on ".concat(window.location.href);
        var metadata = {
            message: message,
            agent_type_key: type,
            uri: window.location.href,
            country_code: market.code,
            store_id: store && store.id,
            price_id: parseInt(priceId, 10),
            price_value: String(priceValue),
            stock_status: stockStatus
        };
        dispatch((0,actions/* reportWrongPrice */.fn)(metadata)); // Action event for tracking
        setSending(true);
        postFeedback(metadata).then(function() {
            setSending(false);
            setSuccess(true);
        }).catch(function() {
            setSending(false);
            setError(true);
        }).then(function() {
            setTimeout(function() {
                setSuccess(false);
                return onClose ? onClose() : closeModal();
            }, 3000);
        });
    }, [
        market.code,
        store,
        priceId,
        priceValue,
        stockStatus,
        actions/* reportWrongPrice */.fn,
        onClose,
        closeModal
    ]);
    var reportWrongPrice = (0,react.useCallback)(function(e) {
        return onReport(e, ReportType.WrongPrice);
    }, [
        onReport
    ]);
    var reportWrongProduct = (0,react.useCallback)(function(e) {
        return onReport(e, ReportType.WrongProduct);
    }, [
        onReport
    ]);
    var reportWrongStockStatus = (0,react.useCallback)(function(e) {
        return onReport(e, ReportType.WrongStockStatus);
    }, [
        onReport
    ]);
    var highResolutionLogo = (store === null || store === void 0 ? void 0 : store.logo) ? {
        url: store.logo,
        width: constants/* SHOP_LOGO_WIDTH */.L9
    } : null;
    return /*#__PURE__*/ react.createElement(modal/* default */.Z, {
        isOpen: isOpen,
        onRequestClose: closeModal,
        shouldShowCloseIcon: !submitted,
        width: 1024
    }, /*#__PURE__*/ react.createElement(StyledContent, null, submitted ? /*#__PURE__*/ react.createElement(StyledSubmitMessage, null, sending && /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        isActive: true,
        position: "none",
        size: 30
    }), success && /*#__PURE__*/ react.createElement(StyledMessage, null, /*#__PURE__*/ react.createElement(check_filled.IconCheckFilled, {
        color: "positive500",
        size: 44
    }), t("feedback", "dialog.thanks-for-feedback")), error && /*#__PURE__*/ react.createElement(StyledMessage, null, /*#__PURE__*/ react.createElement(close_filled.IconCloseFilled, {
        color: "negative700",
        size: 44
    }), t("feedback", "dialog.request-error"))) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledTitle, null, store && store.hasLogo && /*#__PURE__*/ react.createElement(store_logo/* StoreLogo */.Xv, {
        name: store.name,
        storeId: store.id,
        featured: isFeatured,
        hasImage: store.hasLogo,
        variant: store_logo/* StoreLogoVariant.PRICE_LIST */.mA.PRICE_LIST,
        logoUrl: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.url,
        width: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.width,
        showHighResolutionLogo: Boolean(highResolutionLogo)
    })), /*#__PURE__*/ react.createElement(StyledCard, null, productImage && /*#__PURE__*/ react.createElement(StyledProductImage, {
        src: productImage,
        name: productName
    }), /*#__PURE__*/ react.createElement(StyledProductName, null, productName), /*#__PURE__*/ react.createElement(StyledReportDescription, {
        $thin: true
    }, t("feedback", "report.wrong-product-description")), /*#__PURE__*/ react.createElement(StyledButton, {
        onClick: reportWrongProduct,
        fullWidth: true
    }, t("feedback", "report.wrong-product"))), /*#__PURE__*/ react.createElement(StyledCard, null, /*#__PURE__*/ react.createElement(StyledPriceLabel, {
        value: priceValue
    }), /*#__PURE__*/ react.createElement(StyledReportDescription, {
        $thin: true
    }, t("feedback", "report.wrong-price-description")), /*#__PURE__*/ react.createElement(StyledButton, {
        onClick: reportWrongPrice,
        fullWidth: true
    }, t("feedback", "report.wrong-price"))), /*#__PURE__*/ react.createElement(StyledCard, null, /*#__PURE__*/ react.createElement(StyledStockStatus, {
        status: stockStatus,
        size: 46
    }), /*#__PURE__*/ react.createElement(StyledReportDescription, {
        $thin: true
    }, t("feedback", "report.wrong-stock-status-description")), /*#__PURE__*/ react.createElement(StyledButton, {
        onClick: reportWrongStockStatus,
        fullWidth: true
    }, t("feedback", "report.wrong-stock-status"))), /*#__PURE__*/ react.createElement(StyledCard, null, /*#__PURE__*/ react.createElement(StyledReportDescription, null, t("feedback", "report.other-feedback-description")), /*#__PURE__*/ react.createElement(static_intercom/* default */.Z, {
        customButton: /*#__PURE__*/ react.createElement(StyledFeedbackButton, {
            containerProps: {
                title: t("feedback", "report.other-feedback")
            },
            fullWidth: true
        }, t("feedback", "report.other-feedback"))
    })))));
};
/* harmony default export */ const report_modal = (ReportModal);


/***/ }),

/***/ 48335:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95939);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18026);
/* harmony import */ var src_components_carousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8350);
/* harmony import */ var src_components_lightbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95447);
/* harmony import */ var _actions_media__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82005);
/* harmony import */ var _product_media_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13694);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var ProductMediaLightbox = function(props) {
    var close = props.close, media = props.media, _position = props.position, position = _position === void 0 ? 0 : _position;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).t;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var videos = media.videos, images = media.images, largeImages = media.large;
    // Tracking: fired initially when image with index 0 is in view
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        (0,_product_media_tracking__WEBPACK_IMPORTED_MODULE_6__/* .trackProductMediaViewed */ .O)({
            index: 0
        });
    }, []);
    var thumbnails = _toConsumableArray(images || []).concat(_toConsumableArray(videos ? videos.map(function(video) {
        return video.thumbnail ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_carousel__WEBPACK_IMPORTED_MODULE_3__/* .VideoThumbnail */ .uC, {
            key: video.source_id,
            src: video.thumbnail
        }) : null;
    }).filter(function(item) {
        return item;
    }) : []));
    var items = _toConsumableArray(largeImages ? largeImages.map(function(src) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
            key: src,
            src: src,
            alt: ""
        });
    }) : []).concat(_toConsumableArray(videos ? videos.map(function(video) {
        return video.embed_url ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_carousel__WEBPACK_IMPORTED_MODULE_3__/* .Video */ .nk, {
            key: video.source_id,
            src: video.embed_url
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, t("product", "video.brand-disclaimer"))) : null;
    }).filter(function(item) {
        return item;
    }) : []));
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_lightbox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        items: items,
        thumbnails: thumbnails,
        position: position,
        close: close,
        onChange: function(index, type) {
            dispatch((0,_actions_media__WEBPACK_IMPORTED_MODULE_5__/* .productMediaSetPosition */ .Px)(index, {
                action: type
            }));
            (0,_product_media_tracking__WEBPACK_IMPORTED_MODULE_6__/* .trackProductMediaViewed */ .O)({
                index: index
            });
        },
        isOpen: true
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductMediaLightbox);


/***/ }),

/***/ 93922:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": () => (/* binding */ TrackingSettingLabel),
/* harmony export */   "Ee": () => (/* binding */ Image),
/* harmony export */   "X2": () => (/* binding */ Row),
/* harmony export */   "sh": () => (/* binding */ TrackingSetting)
/* harmony export */ });
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61093);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: #efefef;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid #cfcfcf;\n  border-radius: 5px;\n  padding: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  height: 50px;\n  margin-right: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: 700;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Row = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "Row",
    componentId: "sc-0-0"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(props) {
    return props.removed && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject());
});
var Image = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(_templateObject2());
var TrackingSetting = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "TrackingSetting",
    componentId: "sc-0-2"
})(_templateObject3(), function(props) {
    return props.indent ? "50px" : "0";
});
var TrackingSettingLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].span.withConfig({
    displayName: "TrackingSettingLabel",
    componentId: "sc-0-3"
})(_templateObject4(), function(p) {
    return p.theme.colors.base700;
});


/***/ }),

/***/ 95858:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NZ": () => (/* binding */ SectionTitle),
/* harmony export */   "TR": () => (/* binding */ Logo),
/* harmony export */   "bp": () => (/* binding */ ContentColumn),
/* harmony export */   "fC": () => (/* binding */ Root),
/* harmony export */   "q9": () => (/* binding */ BreadCrumbWrapper)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: flex-start;\n  padding: 0 ",
        " 2rem;\n  a {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 1rem 0 0;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 2rem 0 2rem 2rem;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  float: right;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: normal;\n  margin-bottom: 0px;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var ContentColumn = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ContentColumn",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.pageContent.gutter.rem */ .bK.pageContent.gutter.rem);
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].img.withConfig({
    displayName: "Logo",
    componentId: "sc-0-1"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject1()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject2()));
var SectionTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h2.withConfig({
    displayName: "SectionTitle",
    componentId: "sc-0-2"
})(_templateObject5(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(22), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject4(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(18)));
var Root = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Root",
    componentId: "sc-0-3"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.pageContent.gutter.rem */ .bK.pageContent.gutter.rem);
var BreadCrumbWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-4"
})(_templateObject7(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 37631:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ tracking_settings)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(38828);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(45183);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(65208);
// EXTERNAL MODULE: ./config/dist/markets/types.js
var types = __webpack_require__(83109);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(24084);
// EXTERNAL MODULE: ./src/areas/user/components/styles.ts
var styles = __webpack_require__(93922);
;// CONCATENATED MODULE: ./src/areas/user/components/tracking-setting.tsx



var TrackingSettingCheckbox = function(props) {
    return /*#__PURE__*/ react.createElement(styles/* TrackingSetting */.sh, {
        indent: props.indent
    }, /*#__PURE__*/ react.createElement(inputs/* Checkbox */.XZ, {
        name: props.name,
        onChange: function() {
            return props.handleChange(props.name);
        },
        checked: props.checked,
        disabled: props.disabled
    }, /*#__PURE__*/ react.createElement(styles/* TrackingSettingLabel */.AW, null, props.title)), props.text);
};
/* harmony default export */ const tracking_setting = (TrackingSettingCheckbox);

// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(62372);
// EXTERNAL MODULE: ./src/areas/user/actions/tracking.js
var tracking = __webpack_require__(69399);
// EXTERNAL MODULE: ./src/components/cookie-banner/actions/index.ts
var actions = __webpack_require__(61034);
// EXTERNAL MODULE: ./src/components/cookie-banner/index.tsx + 13 modules
var cookie_banner = __webpack_require__(63198);
// EXTERNAL MODULE: ./src/hooks/useEffectOnMount.ts
var useEffectOnMount = __webpack_require__(53249);
// EXTERNAL MODULE: ./src/areas/user/styles.ts
var user_styles = __webpack_require__(95858);
;// CONCATENATED MODULE: ./src/areas/user/tracking-settings.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
















var TrackingSettings = function(props) {
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market, renderMode = ref.renderMode;
    var isMobile = (0,react.useContext)(viewport/* ViewportContext */.R).isMobile;
    var ref1 = _slicedToArray((0,react.useState)(), 2), pulseEnvId = ref1[0], setPulseEnvId = ref1[1];
    var privacySettings = market && market.privacySettings && (market.privacySettings[renderMode] || market.privacySettings.responsive);
    (0,useEffectOnMount/* useEffectOnMount */.O)(function() {
        if (false) {}
        // @ts-expect-error -- Untyped
        if (typeof window.pulse !== "function") {
            return;
        }
        // @ts-expect-error -- Untyped
        window.pulse(function(sdk) {
            return sdk.getEnvironmentId().then(function(id) {
                return setPulseEnvId(id);
            });
        });
    });
    var logoUrl = "".concat(market.cdn, "/g/rfe/logos/schibsted/schibsted_dust_black.png");
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(page/* PageContent */.JH, null, /*#__PURE__*/ react.createElement(user_styles/* BreadCrumbWrapper */.q9, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: [
            {
                title: t("tracking-settings", "page.title")
            }
        ]
    })), /*#__PURE__*/ react.createElement(variants.Column, {
        gap: 1,
        container: user_styles/* ContentColumn */.bp
    }, market.showSchibstedCoBranding && /*#__PURE__*/ react.createElement("div", null, !isMobile && /*#__PURE__*/ react.createElement(user_styles/* Logo */.TR, {
        alt: "Schibsted",
        src: logoUrl,
        width: "128"
    }), /*#__PURE__*/ react.createElement(user_styles/* SectionTitle */.NZ, null, t("tracking-settings", "schibsted-ads.title")), t("tracking-settings", "schibsted-ads.text", {
        editAdPreferencesLink: /*#__PURE__*/ react.createElement("a", {
            id: "schibsted-ad-settings",
            href: "https://aboutme.schibsted.com/p/".concat(market.code, "/ads/").concat(pulseEnvId),
            target: "_blank",
            rel: "noopener noreferrer"
        }, t("tracking-settings", "schibsted-ads.edit-preferences-link")),
        adsReadMoreLink: /*#__PURE__*/ react.createElement("a", {
            href: "https://info.privacy.schibsted.com/".concat(market.code, "/s005/"),
            target: "_blank",
            rel: "noopener noreferrer"
        }, t("tracking-settings", "schibsted-ads.read-more-link"))
    }), isMobile && /*#__PURE__*/ react.createElement(user_styles/* Logo */.TR, {
        alt: "Schibsted",
        src: logoUrl,
        width: "128"
    })), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(user_styles/* SectionTitle */.NZ, null, t("tracking-settings", "personal-data.title")), t("tracking-settings", "personal-data.text", {
        cookiePolicyLink: /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
            to: privacySettings === null || privacySettings === void 0 ? void 0 : privacySettings.cookieUrl
        }, t("common", "cookie-banner.cookie-policy")),
        privacyPolicyLink: /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
            to: privacySettings === null || privacySettings === void 0 ? void 0 : privacySettings.privacyUrl
        }, t("common", "cookie-banner.privacy-policy"))
    })), /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        color: "primary",
        variant: "text",
        onClick: function() {
            props.acceptCookies(privacySettings.cookieVersion, _objectSpread({}, props.settings, cookie_banner/* privacySettingAllRejected */.k3, _defineProperty({}, types.PrivacySettingToggle.BehaviourTrackingImprovement, false)), props.isAuthenticated, true);
        }
    }, t("common", "cookie-banner.reject-button")), /*#__PURE__*/ react.createElement(tracking_setting, {
        title: t("tracking-settings", "necessary-data.title"),
        name: "necessary_data",
        text: t("tracking-settings", "necessary-data.text"),
        checked: true,
        disabled: true,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        handleChange: function() {}
    }), /*#__PURE__*/ react.createElement(tracking_setting, {
        title: t("tracking-settings", "".concat(types.PrivacySettingToggle.BehaviourTrackingImprovement, ".title")),
        name: types.PrivacySettingToggle.BehaviourTrackingImprovement,
        handleChange: function(name) {
            props.trackingToggleChange(name, !props.settings[name]);
        },
        text: t("tracking-settings", "".concat(types.PrivacySettingToggle.BehaviourTrackingImprovement, ".text")),
        checked: props.settings[types.PrivacySettingToggle.BehaviourTrackingImprovement]
    }), /*#__PURE__*/ react.createElement(tracking_setting, {
        title: t("tracking-settings", "".concat(types.PrivacySettingToggle.Personalization, ".title")),
        name: types.PrivacySettingToggle.Personalization,
        handleChange: function(name) {
            props.trackingToggleChange(name, !props.settings[name]);
        },
        text: t("tracking-settings", "".concat(types.PrivacySettingToggle.Personalization, ".text")),
        checked: props.settings[types.PrivacySettingToggle.Personalization],
        disabled: !props.settings[types.PrivacySettingToggle.BehaviourTrackingImprovement],
        indent: true
    }), /*#__PURE__*/ react.createElement(tracking_setting, {
        title: t("tracking-settings", "".concat(types.PrivacySettingToggle.BehaviorTrackingSurveys, ".title")),
        name: types.PrivacySettingToggle.BehaviorTrackingSurveys,
        handleChange: function(name) {
            props.trackingToggleChange(name, !props.settings[name]);
        },
        text: t("tracking-settings", "".concat(types.PrivacySettingToggle.BehaviorTrackingSurveys, ".text")),
        checked: props.settings[types.PrivacySettingToggle.BehaviorTrackingSurveys]
    }), /*#__PURE__*/ react.createElement(tracking_setting, {
        title: t("tracking-settings", "".concat(types.PrivacySettingToggle.BehaviorTrackingMarketing, ".title")),
        name: types.PrivacySettingToggle.BehaviorTrackingMarketing,
        handleChange: function(name) {
            props.trackingToggleChange(name, !props.settings[name]);
        },
        text: t("tracking-settings", "".concat(types.PrivacySettingToggle.BehaviorTrackingMarketing, ".text")),
        checked: props.settings[types.PrivacySettingToggle.BehaviorTrackingMarketing]
    }), /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        color: "positive",
        variant: "outlined",
        onClick: function() {
            props.acceptCookies(privacySettings.cookieVersion, props.settings, props.isAuthenticated, true);
        }
    }, t("common", "button.save")))));
};
var mapStateToProps = function(state) {
    return {
        isAuthenticated: state.areas.account.isAuthenticated,
        settings: state.areas.user.tracking.settings
    };
};
var dispatchActions = {
    acceptCookies: actions/* default */.Z,
    trackingToggleChange: tracking/* default.trackingToggleChange */.ZP.trackingToggleChange,
    trackingToggleSave: tracking/* default.trackingToggleSave */.ZP.trackingToggleSave
};
/* harmony default export */ const tracking_settings = ((0,es/* connect */.$j)(mapStateToProps, dispatchActions)(/*#__PURE__*/ (0,react.memo)(TrackingSettings)));


/***/ }),

/***/ 8350:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lr": () => (/* reexport */ carousel),
  "nk": () => (/* reexport */ Video),
  "uC": () => (/* reexport */ VideoThumbnail)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/detect-it@4.0.1/node_modules/detect-it/dist/detect-it.esm.js
var detect_it_esm = __webpack_require__(45115);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-swipe@6.0.4/node_modules/react-swipe/lib/index.js
var lib = __webpack_require__(13708);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(26959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(98841);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/index.tsx + 1 modules
var horizontal_scroll = __webpack_require__(55913);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/carousel/components/carousel/carousel-item.tsx

var CarouselItem = function(param) {
    var item = param.item, _inView = param.inView, inView = _inView === void 0 ? false : _inView, _onClick = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    return /*#__PURE__*/ react.cloneElement(item, {
        onClick: onClick,
        "data-test": "CarouselItem",
        inview: inView ? 1 : 0
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(38828);
;// CONCATENATED MODULE: ./src/components/carousel/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 40%;\n  background: ",
        ";\n  z-index: 1;\n  opacity: 0;\n  transition: opacity 0.5s;\n  color: ",
        ";\n\n  && {\n    svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n\n  &&:hover,\n  &&:focus {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: auto;\n  position: relative;\n  outline: 0;\n\n  &:hover {\n    ",
        " {\n      opacity: 1;\n    }\n  }\n\n  &--current,\n  &--prev,\n  &--next {\n    display: flex;\n    flex: 0 0 100%;\n    justify-content: center;\n    align-items: center;\n\n    > * {\n      max-height: inherit;\n      max-width: 100%;\n      width: auto;\n    }\n\n    &-animate-left {\n      transform: translate3d(100%, 0, 0);\n    }\n\n    &-animate-right {\n      transform: translate3d(-100%, 0, 0);\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  > * {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-height: 100%;\n    max-width: 100%;\n    width: auto;\n    min-width: 1px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  padding-top: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  display: flex;\n  padding-top: 25px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  width: 80px;\n  display: inline-block;\n  margin: 3px;\n  border: 1px solid transparent;\n  ",
        "\n\n  img {\n    height: 80px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  height: 10px;\n  width: 10px;\n  margin: 5px;\n  display: inline-block;\n  background-color: transparent;\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var SwitchButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "SwitchButton",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.buttons.panning.bg;
}, function(p) {
    return p.theme.buttons.panning.text;
}, function(p) {
    return p.theme.buttons.panning.text;
}, function(p) {
    return p.theme.buttons.panning.bgHover;
});
var CarouselWrapper = styled_components_browser_esm["default"].div.attrs({
    "data-test": "Carousel"
}).withConfig({
    displayName: "CarouselWrapper",
    componentId: "sc-0-1"
})(_templateObject1(), SwitchButton);
var CarouselSlide = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CarouselSlide",
    componentId: "sc-0-2"
})(_templateObject2());
var CarouselSlideContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CarouselSlideContainer",
    componentId: "sc-0-3"
})(_templateObject3());
var IndicatorWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IndicatorWrapper",
    componentId: "sc-0-4"
})(_templateObject4());
var ThumbnailWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ThumbnailWrapper",
    componentId: "sc-0-5"
})(_templateObject5());
var Thumbnail = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Thumbnail",
    componentId: "sc-0-6"
})(_templateObject7(), function(p) {
    return p.selected && (0,styled_components_browser_esm.css)(_templateObject6(), p.theme.colors.base0);
});
var Indicator = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Indicator",
    componentId: "sc-0-7"
})(_templateObject9(), function(p) {
    return p.theme.colors.base500;
}, function(p) {
    return p.selected && (0,styled_components_browser_esm.css)(_templateObject8(), p.theme.colors.base500);
});

;// CONCATENATED MODULE: ./src/components/carousel/components/carousel/carousel.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}











var SWIPE = "swipe";
var THUMBNAIL = "thumbnail";
var DOT = "dot";
var _Component;
var Carousel = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(Carousel, _superClass);
    var _super = _createSuper(Carousel);
    function Carousel(props) {
        _classCallCheck(this, Carousel);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "reactSwipe", null);
        _defineProperty(_assertThisInitialized(_this), "disableOnChange", false);
        _this.state = {
            currentPosition: 0
        };
        return _this;
    }
    _createClass(Carousel, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.focus) {
                    this.carousel.focus();
                }
                if (this.props.position !== null) {
                    // eslint-disable-next-line react/no-did-mount-set-state
                    this.setState({
                        currentPosition: this.props.position
                    });
                }
            }
        },
        {
            key: "setPosition",
            value: function setPosition(newPosition, type) {
                var // React swipe needs it's own emitted position to work
                // correctly if it uses more slides behind the scenes
                ref;
                this.props.onChange(newPosition, type);
                // Use this flag to make sure we don't send
                // two onChange events when adjusting slide
                this.disableOnChange = true;
                (ref = this.reactSwipe) === null || ref === void 0 ? void 0 : ref.slide(newPosition);
                this.setState({
                    currentPosition: newPosition
                });
            }
        },
        {
            key: "handleOnClick",
            value: function handleOnClick(e) {
                if (this.indicatorWrapper) {
                    if (e.target === this.indicatorWrapper || this.indicatorWrapper.contains(e.target)) {
                        return;
                    }
                }
                this.props.onClick();
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(e) {
                var ENTER = 13, SPACE = 32, LEFT = 37, RIGHT = 39;
                switch(e.keyCode){
                    case SPACE:
                        // Prevent default scroll behavior when space is hit
                        e.preventDefault();
                        this.props.onClick();
                        break;
                    case ENTER:
                        this.props.onClick();
                        break;
                    case LEFT:
                        var ref;
                        (ref = this.reactSwipe) === null || ref === void 0 ? void 0 : ref.prev();
                        break;
                    case RIGHT:
                        var ref1;
                        (ref1 = this.reactSwipe) === null || ref1 === void 0 ? void 0 : ref1.next();
                        break;
                    default:
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var t = this.context.t;
                var _props = this.props, height = _props.height, fallback = _props.fallback, thumbnails = _props.thumbnails, showArrows = _props.showArrows, showIndicator = _props.showIndicator, transitionTime = _props.transitionTime, clickForNext = _props.clickForNext;
                // Dynamic content might be empty, use fallback
                if (!this.props.children) {
                    return /*#__PURE__*/ react.createElement(CarouselWrapper, {
                        className: "pj-ui-carousel"
                    }, fallback);
                }
                var children = react.Children.toArray(this.props.children).filter(function(child) {
                    return child;
                });
                var childCount = react.Children.count(children);
                var singleItem = childCount === 1;
                var showIndicators = !thumbnails && showIndicator && childCount > 1;
                var showThumbnails = thumbnails && childCount > 1;
                var reactSwipeStyles = Carousel.getSwipeStyles();
                reactSwipeStyles.wrapper = _objectSpreadProps(_objectSpread({}, reactSwipeStyles.wrapper), {
                    maxHeight: "100%"
                });
                return /*#__PURE__*/ react.createElement(CarouselWrapper, {
                    ref: function(div) {
                        _this.carousel = div;
                    },
                    role: "button",
                    tabIndex: 0,
                    className: "pj-ui-carousel",
                    onClick: function(e) {
                        return _this.handleOnClick(e);
                    },
                    onKeyDown: function(e) {
                        return _this.handleKeyDown(e);
                    },
                    style: {
                        minHeight: height
                    }
                }, showArrows && !singleItem && /*#__PURE__*/ react.createElement(SwitchButton, {
                    style: {
                        left: "3%"
                    },
                    size: "large",
                    variant: "icon",
                    color: "secondary",
                    icon: /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, null),
                    ariaLabel: t("symbols", "symbol.show-prev"),
                    onClick: function() {
                        var ref;
                        return (ref = _this.reactSwipe) === null || ref === void 0 ? void 0 : ref.prev();
                    },
                    "data-test": "SwitchButton"
                }), !singleItem ? /*#__PURE__*/ react.createElement((lib_default()), {
                    ref: function(reactSwipe) {
                        _this.reactSwipe = reactSwipe;
                    },
                    key: childCount,
                    style: reactSwipeStyles,
                    swipeOptions: {
                        auto: 0,
                        startSlide: this.state.currentPosition,
                        speed: transitionTime,
                        disableScroll: false,
                        continuous: true,
                        callback: function(pos) {
                            _this.setState({
                                currentPosition: pos
                            });
                            if (!_this.disableOnChange) {
                                _this.props.onChange(pos, SWIPE);
                            }
                            _this.disableOnChange = false;
                        }
                    }
                }, react.Children.map(children, function(child, index) {
                    /*#__PURE__*/ return react.createElement(CarouselSlide, {
                        key: index,
                        className: "pj-ui-carousel--slide",
                        style: {
                            maxHeight: height
                        }
                    }, /*#__PURE__*/ react.createElement(CarouselItem, {
                        inView: index === _this.state.currentPosition,
                        item: child,
                        onClick: clickForNext ? function() {
                            var ref;
                            return (ref = _this.reactSwipe) === null || ref === void 0 ? void 0 : ref.next();
                        } : null
                    }));
                })) : this.props.children, showArrows && !singleItem && /*#__PURE__*/ react.createElement(SwitchButton, {
                    style: {
                        right: "3%"
                    },
                    size: "large",
                    variant: "icon",
                    color: "secondary",
                    icon: /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null),
                    ariaLabel: t("symbols", "symbol.show-next"),
                    onClick: function() {
                        var ref;
                        return (ref = _this.reactSwipe) === null || ref === void 0 ? void 0 : ref.next();
                    },
                    "data-test": "SwitchButton"
                }), showThumbnails && /*#__PURE__*/ react.createElement(ThumbnailWrapper, {
                    className: "pj-ui-carousel--thumbnail-wrapper"
                }, /*#__PURE__*/ react.createElement(horizontal_scroll/* HorizontalScroll */.Z, {
                    loadingHeight: 80,
                    itemWidth: 90
                }, thumbnails.map(function(thumbnail, index) {
                    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
                    /*#__PURE__*/ react.createElement(Thumbnail, {
                        key: thumbnail,
                        role: "button",
                        tabIndex: index,
                        onClick: function() {
                            return _this.setPosition(index, THUMBNAIL);
                        },
                        className: "pj-ui-carousel--thumbnail",
                        selected: index === _this.state.currentPosition
                    }, typeof thumbnail === "string" ? /*#__PURE__*/ react.createElement("img", {
                        src: thumbnail,
                        alt: ""
                    }) : thumbnail));
                }))), showIndicators && /*#__PURE__*/ react.createElement(IndicatorWrapper, {
                    ref: function(div) {
                        _this.indicatorWrapper = div;
                    },
                    className: "pj-ui-carousel--indicator-wrapper"
                }, children.map(function(_, index) {
                    return(// eslint-disable-next-line jsx-a11y/control-has-associated-label
                    /*#__PURE__*/ react.createElement(Indicator, {
                        key: index,
                        type: "button",
                        onClick: function() {
                            return _this.setPosition(index, DOT);
                        },
                        selected: index === _this.state.currentPosition,
                        className: "pj-ui-carousel--indicator"
                    }));
                })));
            }
        }
    ], [
        {
            key: "getSwipeStyles",
            value: function getSwipeStyles() {
                if (!(lib_default()).defaultProps.style.wrapper) {
                    throw new Error("ReactSwipe is missing defaultProps.style.wrapper");
                }
                return _objectSpreadProps(_objectSpread({}, (lib_default()).defaultProps.style), {
                    wrapper: _objectSpreadProps(_objectSpread({}, (lib_default()).defaultProps.style.wrapper), {
                        display: "flex"
                    })
                });
            }
        }
    ]);
    return Carousel;
}(_Component = react.Component);
_defineProperty(Carousel, "deriveStateFromProps", function(nextProps) {
    Carousel.setState({
        currentPosition: nextProps.position
    });
});
var node = (prop_types_default()).node, number = (prop_types_default()).number, func = (prop_types_default()).func, arrayOf = (prop_types_default()).arrayOf, bool = (prop_types_default()).bool, string = (prop_types_default()).string;
Carousel.propTypes = {
    height: string.isRequired,
    focus: bool,
    showArrows: bool,
    showIndicator: bool,
    position: number,
    children: node,
    fallback: node,
    thumbnails: arrayOf(node),
    onClick: func,
    onChange: func,
    transitionTime: number,
    clickForNext: bool
};
Carousel.defaultProps = {
    position: null,
    focus: false,
    showArrows: [
        "hybrid",
        "mouseOnly"
    ].includes(detect_it_esm/* deviceType */.vO),
    showIndicator: true,
    children: null,
    fallback: null,
    thumbnails: null,
    onClick: base/* noop */.ZT,
    onChange: base/* noop */.ZT,
    transitionTime: 300,
    clickForNext: false
};
Carousel.contextType = app_context/* AppContext */.Il;
/* harmony default export */ const carousel = (Carousel);

;// CONCATENATED MODULE: ./src/components/carousel/components/video/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.8;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 100%;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  flex: 1;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin-bottom: 30px;\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: small;\n  font-style: italic;\n  margin-bottom: 20px;\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var styles_Thumbnail = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Thumbnail",
    componentId: "sc-0-0"
})(styles_templateObject());
var PlayIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PlayIconWrapper",
    componentId: "sc-0-1"
})(styles_templateObject1());
var VideoWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoWrapper",
    componentId: "sc-0-2"
})(styles_templateObject2());
var VideoFrame = styled_components_browser_esm["default"].iframe.withConfig({
    displayName: "VideoFrame",
    componentId: "sc-0-3"
})(styles_templateObject3());
var VideoChildrenContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoChildrenContainer",
    componentId: "sc-0-4"
})(styles_templateObject5(), base/* media.mediumUp */.BC.mediumUp(styles_templateObject4()));

;// CONCATENATED MODULE: ./src/components/carousel/components/video/video.tsx


var Video = function(param) {
    var src = param.src, children = param.children, _hideWhenNotInView = param.hideWhenNotInView, hideWhenNotInView = _hideWhenNotInView === void 0 ? true : _hideWhenNotInView, _height = param.height, height = _height === void 0 ? "450px" : _height, _inview = param.inview, inview = _inview === void 0 ? 0 : _inview;
    if (inview === 0 && hideWhenNotInView) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(VideoWrapper, {
        className: "pj-ui-carousel-video",
        style: {
            height: height
        }
    }, /*#__PURE__*/ react.createElement(VideoFrame, {
        src: src,
        title: src
    }), /*#__PURE__*/ react.createElement(VideoChildrenContainer, {
        className: "pj-ui-carousel-video--children"
    }, children));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/youtube/index.js
var youtube = __webpack_require__(21873);
;// CONCATENATED MODULE: ./src/components/carousel/components/video/video-thumbnail.tsx



var VideoThumbnail = function(props) {
    return /*#__PURE__*/ react.createElement(styles_Thumbnail, {
        className: "pj-ui-carousel-video-thumbnail"
    }, /*#__PURE__*/ react.createElement(PlayIconWrapper, {
        className: "pj-ui-carousel-video-thumbnail--play-icon"
    }, /*#__PURE__*/ react.createElement(youtube/* IconYoutube */.z, null)), /*#__PURE__*/ react.createElement("img", {
        src: props.src,
        alt: ""
    }));
};

;// CONCATENATED MODULE: ./src/components/carousel/index.ts






/***/ }),

/***/ 88669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* reexport */ DropdownItem)
});

// UNUSED EXPORTS: SharedListItemStyles

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/dropdown-item/dropdown-item.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  svg {\n    margin-right: ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SharedListItemStyles = (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var DropdownItem = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-0"
})(_templateObject1(), SharedListItemStyles);

;// CONCATENATED MODULE: ./src/components/dropdown-item/index.ts



/***/ }),

/***/ 83628:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": () => (/* reexport */ Grid)
});

// UNUSED EXPORTS: GridRow

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/flexible-grid/grid.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        margin-bottom: ",
        ";\n        margin-right: ",
        ";\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  /* Basic fallback for IE11 */\n\n  display: flex;\n  flex-wrap: wrap;\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-gap: ",
        ";\n\n  > * {\n    /* grid-gap fallback for IE11 */\n    ",
        "\n\n    @supports (display: grid) {\n      margin-bottom: 0;\n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

/* stylelint-disable declaration-block-no-duplicate-properties */ var Grid = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Grid",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.columnTemplate || "repeat(".concat(props.columnCount || "auto-fill", ", minmax(").concat(props.columnMinWidth || "auto", ", ").concat(props.columnMaxWidth || "1fr", "))");
}, function(props) {
    return props.gap || "10px";
}, function(props) {
    return props.gap && (0,styled_components_browser_esm.css)(_templateObject(), props.gap, props.gap);
});

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/flexible-grid/grid-row.js
function grid_row_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function grid_row_templateObject() {
    var data = grid_row_taggedTemplateLiteral([
        "\n  grid-column: 1 / -1;\n  grid-row-start: ",
        ";\n\n  /* Fallback for browsers without grid support */\n  flex: 1 0 100%;\n  order: 1;\n"
    ]);
    grid_row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GridRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridRow",
    componentId: "sc-0-0"
})(grid_row_templateObject(), function(props) {
    return props.row;
});
var number = (prop_types_default()).number, node = (prop_types_default()).node;
GridRow.propTypes = {
    children: node,
    row: number
};
GridRow.defaultProps = {
    children: undefined,
    row: 1
};

;// CONCATENATED MODULE: ./src/components/flexible-grid/index.ts





/***/ }),

/***/ 95447:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var LightBox = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 89504));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(89504);
        }
        return eval("require.resolve")("./lightbox");
    }
});
var LoadableLightBox = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LightBox, _extends({}, props));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LoadableLightBox);


/***/ }),

/***/ 89504:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ lightbox)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/carousel/index.ts + 6 modules
var carousel = __webpack_require__(8350);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(84198);
// EXTERNAL MODULE: ./src/components/modal/index.tsx
var modal = __webpack_require__(58203);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/lightbox/styles.ts


var Lightbox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Lightbox",
    componentId: "sc-0-0"
})({
    width: "100%",
    maxWidth: "1024px",
    maxHeight: "90vh",
    padding: "40px",
    ".pj-ui-carousel": {
        outline: "none"
    }
}, base/* media.smallOnly */.BC.smallOnly({
    top: 0,
    width: "100%",
    height: "100%",
    maxHeight: "none",
    borderRadius: "unset"
}));

;// CONCATENATED MODULE: ./src/components/lightbox/lightbox.tsx






var lightbox_Lightbox = function(param) {
    var items = param.items, _position = param.position, position = _position === void 0 ? 0 : _position, thumbnails = param.thumbnails, _onChange = param.onChange, onChange = _onChange === void 0 ? base/* noop */.ZT : _onChange, isOpen = param.isOpen, close = param.close, width = param.width;
    var isMobile = (0,react.useContext)(context/* default */.ZP).isMobile;
    (0,react.useEffect)(function() {
        return function() {
            close();
        };
    });
    var height = isMobile ? "300px" : "450px";
    return /*#__PURE__*/ react.createElement(modal/* default */.Z, {
        id: "lightboxModal",
        isOpen: isOpen,
        onRequestClose: close,
        width: width,
        verticalScroll: true
    }, /*#__PURE__*/ react.createElement(Lightbox, null, /*#__PURE__*/ react.createElement(carousel/* Carousel */.lr, {
        focus: true,
        height: height,
        position: position,
        onChange: onChange,
        thumbnails: isMobile ? null : thumbnails,
        clickForNext: true
    }, items.map(function(item) {
        return item;
    }))));
};
/* harmony default export */ const lightbox = (lightbox_Lightbox);


/***/ }),

/***/ 62122:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16494);


var APP_ROOT_ID = "root";
var MODAL_ROOT_ID = "root-modal";
var ModalComponent = function(props) {
    var children = props.children, className = props.className, isOpen = props.isOpen, onRequestClose = props.onRequestClose, _size = props.size, size = _size === void 0 ? _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_1__/* .ModalSizeEnum.NORMAL */ .E$.NORMAL : _size, style = props.style, title = props.title;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, {
        className: className,
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        parentSelectorId: MODAL_ROOT_ID,
        rootId: APP_ROOT_ID,
        size: size,
        style: style,
        title: title
    }, children);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalComponent);


/***/ }),

/***/ 22993:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ modal)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-modal@3.8.1_react-dom@18.2.0_react@18.2.0/node_modules/react-modal/lib/index.js
var lib = __webpack_require__(35066);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(66275);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(93497);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(38828);
;// CONCATENATED MODULE: ./src/components/modal/index.styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: 90vw;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: 90vw;\n      padding: ",
        ";\n      margin-top: ",
        "px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n          padding: ",
        " 0;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      margin: 0;\n      padding: $padding-wrapper 0;\n\n      ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    padding: ",
        ";\n    background: #fff;\n    border-radius: ",
        ";\n    overflow: hidden;\n    outline: 0;\n    display: flex;\n    flex-flow: row wrap;\n    position: absolute;\n    margin: ",
        "px auto;\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n\n    h1 {\n      font-size: 2.2rem;\n    }\n    > h1,\n    > h2,\n    > h3,\n    > h4,\n    > h5,\n    > h6 {\n      &:first-child {\n        margin-top: 0;\n        margin-bottom: 0.5em;\n        line-height: 1.2em;\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 0 ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 0 ",
        ";\n  max-height: 80vh;\n  overflow-y: auto;\n\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  width: 40px;\n  height: 40px;\n  user-select: none;\n  cursor: pointer;\n  border: none;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm["default"])((lib_default())).withConfig({
    displayName: "Modal",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.borderRadius */.bK.borderRadius, base/* layout.headerHeight.desktop.value */.bK.headerHeight.desktop.value, base/* media.mediumDown */.BC.mediumDown(_templateObject()), base/* media.smallOnly */.BC.smallOnly(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.headerHeight.mobile.value */.bK.headerHeight.mobile.value / 2), props.$verticalScroll && (0,styled_components_browser_esm.css)(_templateObject3(), base/* media.smallOnly */.BC.smallOnly(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050)));
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(_templateObject5());
var Viewport = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Viewport",
    componentId: "sc-0-2"
})(_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var CloseButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-3"
})(_templateObject8(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/components/modal/modal.tsx







var APP_ROOT_ID = "root";
var MODAL_ROOT_ID = "root-modal";
var getModalRoot = function() {
    return document.getElementById(MODAL_ROOT_ID);
};
var modal_Modal = function(props) {
    react.useEffect(function() {
        lib_default().setAppElement("#".concat(APP_ROOT_ID));
    }, []);
    var children = props.children, className = props.className, dataTest = props.dataTest, id = props.id, _isOpen = props.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, onRequestClose = props.onRequestClose, _shouldShowCloseIcon = props.shouldShowCloseIcon, shouldShowCloseIcon = _shouldShowCloseIcon === void 0 ? true : _shouldShowCloseIcon, _shouldCloseOnOverlayClick = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _shouldCloseOnOverlayClick === void 0 ? true : _shouldCloseOnOverlayClick, _verticalScroll = props.verticalScroll, verticalScroll = _verticalScroll === void 0 ? false : _verticalScroll, _width = props.width, width = _width === void 0 ? "auto" : _width;
    var current = (0,es/* useSelector */.v9)(function(state) {
        return state.modal.current;
    });
    return /*#__PURE__*/ react.createElement(Modal, {
        id: id,
        className: className,
        isOpen: isOpen || !!current && current === id,
        onRequestClose: onRequestClose,
        parentSelector: getModalRoot,
        $verticalScroll: verticalScroll,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        style: {
            content: {
                width: width
            },
            overlay: {
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                height: "100%",
                width: "100%",
                background: base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(base/* colors.lightTheme.base700 */.O9.lightTheme.base700, "0.8"),
                overflow: "auto",
                zIndex: zindex/* zindex.modal */.Y.modal,
                overflowY: "scroll",
                WebkitOverflowScrolling: "touch",
                display: "flex",
                justifyContent: "center"
            }
        }
    }, /*#__PURE__*/ react.createElement(Wrapper, {
        "data-test": dataTest
    }, verticalScroll ? /*#__PURE__*/ react.createElement(Viewport, null, children) : children, shouldShowCloseIcon && /*#__PURE__*/ react.createElement(CloseButton, {
        variant: "icon",
        onClick: function() {
            if (onRequestClose) onRequestClose();
        },
        tabIndex: 0,
        icon: /*#__PURE__*/ react.createElement(icon_close.IconClose, null),
        "data-test": "ModalDialogCloseButton"
    })));
};
/* harmony default export */ const modal = (modal_Modal);


/***/ }),

/***/ 87402:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": () => (/* reexport */ ColorsEnum),
  "V": () => (/* binding */ Placeholder)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/placeholder/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n\n  @keyframes gradient {\n    0% {\n      background-position: 100% 50%;\n    }\n    100% {\n      background-position: -100% 50%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    min-width: 146px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: space-between;\n      padding-bottom: 10%;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      max-height: 88px;\n      flex-direction: row;\n      flex-wrap: nowrap;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  flex-grow: 1;\n  min-width: 200px;\n\n  ",
        "\n  ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      align-self: center;\n      height: 100px;\n      width: 100px;\n      margin-bottom: 10px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    order: ",
        ";\n    display: flex;\n    height: 50px;\n    width: 50px;\n    background: ",
        ";\n    border-radius: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: 12px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      margin-top: 20px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      order: ",
        ";\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n      background: linear-gradient(\n        to right,\n        rgba(238, 238, 238, 1) 8%,\n        rgba(238, 238, 238, 0.5) 18%,\n        rgba(238, 238, 238, 1) 33%\n      );\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      background: linear-gradient(to right, #fff 8%, #ffffff80 18%, #fff 33%);\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    display: flex;\n    height: 10px;\n    margin: 5px 0;\n    width: 100%;\n    background-size: 300% 300%;\n    animation: gradient 1s linear infinite;\n    border-radius: 30px;\n\n    ",
        "\n\n    ",
        "\n\n    &:nth-of-type(even) {\n      width: 80%;\n    }\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var ColorsEnum;
(function(ColorsEnum) {
    ColorsEnum["WHITE"] = "white";
    ColorsEnum["GRAY"] = "gray";
})(ColorsEnum || (ColorsEnum = {}));
var StyledPlaceholder = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPlaceholder",
    componentId: "sc-0-0"
})(_templateObject());
var StyledDeal = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledDeal",
    componentId: "sc-0-1"
})(_templateObject4(), function(props) {
    return props.height;
}, base/* media.smallOnly */.BC.smallOnly(_templateObject1()), function(props) {
    return props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject2());
}, function(props) {
    return props.mode === "row" && (0,styled_components_browser_esm.css)(_templateObject3());
});
var StyledMedia = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledMedia",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject6(), props.mediaPosition, props.$color === ColorsEnum.GRAY ? "#eee" : "#fff", base/* layout.borderRadius */.bK.borderRadius, props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject5()));
});
var StyledRows = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledRows",
    componentId: "sc-0-3"
})(_templateObject9(), function(props) {
    return props.mode === "row" && (0,styled_components_browser_esm.css)(_templateObject7());
}, function(props) {
    return props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject8());
});
var StyledText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledText",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject13(), props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject10(), props.rowIndex && props.rowIndex + 1), props.$color === ColorsEnum.GRAY && (0,styled_components_browser_esm.css)(_templateObject11()), props.$color === ColorsEnum.WHITE && (0,styled_components_browser_esm.css)(_templateObject12()));
});

;// CONCATENATED MODULE: ./src/components/placeholder/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var Placeholder = function(param) {
    var className = param.className, _amount = param.amount, amount = _amount === void 0 ? 1 : _amount, _color = param.color, color = _color === void 0 ? ColorsEnum.GRAY : _color, _rows = param.rows, rows = _rows === void 0 ? 5 : _rows, _mode = param.mode, mode = _mode === void 0 ? "grid" : _mode, _height = param.height, height = _height === void 0 ? "auto" : _height, _mediaPosition = param.mediaPosition, mediaPosition = _mediaPosition === void 0 ? 0 : _mediaPosition, _showMedia = param.showMedia, showMedia = _showMedia === void 0 ? true : _showMedia;
    return /*#__PURE__*/ react.createElement(StyledPlaceholder, {
        "data-test": "Placeholder"
    }, _toConsumableArray(new Array(amount)).map(function(e, i) {
        return /*#__PURE__*/ react.createElement(StyledDeal, {
            key: i.toString(),
            mode: mode,
            height: height
        }, showMedia && /*#__PURE__*/ react.createElement(StyledMedia, {
            mediaPosition: mediaPosition,
            mode: mode,
            $color: color
        }), /*#__PURE__*/ react.createElement(StyledRows, {
            mode: mode
        }, _toConsumableArray(new Array(rows)).map(function(row, rowIndex) {
            return /*#__PURE__*/ react.createElement(StyledText, {
                key: rowIndex.toString(),
                rowIndex: rowIndex,
                mode: mode,
                $color: color
            });
        })));
    }));
};



/***/ }),

/***/ 9189:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "tr": () => (/* binding */ Variants)
/* harmony export */ });
/* unused harmony export Colors */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18026);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10182);
/* harmony import */ var _prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79234);
/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/control-has-associated-label */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var Variants;
(function(Variants) {
    Variants["rate"] = "rate";
    Variants["scale"] = "scale";
    Variants["boolean"] = "boolean";
    Variants[// Experimental new boolean presentation, similar to regular buttons
    "booleanV2"] = "booleanV2";
})(Variants || (Variants = {}));
var Colors;
(function(Colors) {
    Colors["negative"] = "negative";
    Colors["neutral"] = "neutral";
    Colors["positive"] = "positive";
})(Colors || (Colors = {}));
var ratingColorMap = [
    Colors.negative,
    Colors.negative,
    Colors.neutral,
    Colors.positive,
    Colors.positive
];
var MultiRadio = function(param) {
    var currentValue = param.currentValue, disabledOptions = param.disabledOptions, _labels = param.labels, labels = _labels === void 0 ? [] : _labels, name = param.name, onClick = param.onClick, options = param.options, _optionValues = param.optionValues, optionValues = _optionValues === void 0 ? [] : _optionValues, required = param.required, _size = param.size, size = _size === void 0 ? "medium" : _size, variant = param.variant;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).t;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue ? optionValues[currentValue - 1] : undefined), 2), selected = ref[0], setSelected = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue ? ratingColorMap[currentValue - 1] : Colors.neutral), 2), ratingColor = ref1[0], setRatingColor = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), error = ref2[0], setError = ref2[1];
    var ref3 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue), 2), checked = ref3[0], setChecked = ref3[1];
    var getSize = function() {
        switch(size){
            case "small":
                return 20;
            case "medium":
            default:
                return 32;
        }
    };
    var iconSize = getSize();
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (e.target.checkValidity()) {
            setError(null);
        }
        setSelected(e.target.dataset.value);
        setChecked(parseInt(e.target.value, 10));
        if (variant === Variants.rate) {
            var index = Number(e.target.value) - 1;
            setRatingColor(ratingColorMap[index]);
        }
        if (onClick) onClick(e);
    }, [
        onClick,
        variant
    ]);
    var getIsDisabled = function(option) {
        return (disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.length) ? (disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.find(function(item) {
            return item === option;
        })) !== undefined : false;
    };
    var handleInvalidity = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (error === e.target.name) return;
        setError(e.target.name);
    }, [
        error
    ]);
    if (variant === Variants.rate) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity
        }, options.map(function(option, index) {
            switch(option){
                case 1:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonAngryIcon */ .u7, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 2:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonDissatisfiedIcon */ .fV, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 3:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonNeutralIcon */ .cI, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 4:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonSmilingIcon */ .oX, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 5:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues.length ? optionValues[index] : undefined,
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonLaughingIcon */ .mv, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                default:
                    return null;
            }
        }), selected && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .SelectedRating */ .u1, {
            color: ratingColor
        }, selected)), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    if (variant === Variants.scale) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity,
            hasSelected: Boolean(optionValues.length),
            showError: error === name
        }, optionValues.length ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Selected */ .Ne, null, selected !== null && selected !== void 0 ? selected : t("reviews", "form.question-nothing-selected")) : null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Inputs */ .kq, null, options.map(function(option, index) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                key: option
            }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ScaleRadio */ .az, {
                type: "radio",
                name: name,
                id: "".concat(name, ":").concat(option),
                value: option,
                "data-value": optionValues.length ? optionValues[index] : undefined,
                required: required,
                onChange: handleChange,
                alignRight: index + 1 === options.length,
                alignLeft: index === 0,
                showError: error === name,
                tabIndex: 0,
                checked: checked === option
            }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                htmlFor: "".concat(name, ":").concat(option),
                "data-label": labels.length ? labels[index] : null
            }));
        }))), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    if (variant === Variants.boolean || variant === Variants.booleanV2) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity,
            showError: error === name
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Inputs */ .kq, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":1"),
            value: "1",
            "data-value": t("reviews", "form.boolean-yes"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 1,
            variant: variant
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":1")
        }, t("reviews", "form.boolean-yes")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":0"),
            value: "0",
            "data-value": t("reviews", "form.boolean-no"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 0,
            variant: variant
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":0")
        }, t("reviews", "form.boolean-no")), options.length > 2 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":2"),
            value: "2",
            "data-value": t("reviews", "form.boolean-unknown"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 2,
            variant: variant
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":2")
        }, t("reviews", "form.boolean-no"))) : null)), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MultiRadio);


/***/ }),

/***/ 10182:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N$": () => (/* binding */ RadioRating),
/* harmony export */   "Ne": () => (/* binding */ Selected),
/* harmony export */   "az": () => (/* binding */ ScaleRadio),
/* harmony export */   "cI": () => (/* binding */ EmoticonNeutralIcon),
/* harmony export */   "fV": () => (/* binding */ EmoticonDissatisfiedIcon),
/* harmony export */   "jj": () => (/* binding */ Error),
/* harmony export */   "kq": () => (/* binding */ Inputs),
/* harmony export */   "mv": () => (/* binding */ EmoticonLaughingIcon),
/* harmony export */   "ng": () => (/* binding */ MultiRadio),
/* harmony export */   "oX": () => (/* binding */ EmoticonSmilingIcon),
/* harmony export */   "qV": () => (/* binding */ BooleanRadio),
/* harmony export */   "u1": () => (/* binding */ SelectedRating),
/* harmony export */   "u7": () => (/* binding */ EmoticonAngryIcon),
/* harmony export */   "uZ": () => (/* binding */ RadioDot)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var src_ui_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92356);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9189);
/* stylelint-disable */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  opacity: 0;\n  position: absolute;\n  pointer-events: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: row;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n          height: ",
        ";\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n            top: ",
        "px;\n          "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      display: inline-flex;\n      position: relative;\n      height: ",
        ";\n      align-items: flex-start;\n      width: 100%;\n\n      ",
        ";\n\n      ",
        " {\n        width: 100%;\n        justify-content: space-between;\n\n        &::after {\n          content: '';\n          width: 100%;\n          position: absolute;\n          top: ",
        "px;\n          z-index: 1;\n          border-top: 1px solid\n            ",
        ";\n\n          ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      display: inline-flex;\n      background: #eee;\n      padding: 2px;\n      border-radius: 4px;\n\n      box-shadow: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: row;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: ",
        ";\n    border-radius: 20px;\n    background: ",
        ";\n    padding: 1px ",
        ";\n    color: ",
        ";\n    line-height: initial;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  height: 20px;\n  max-height: 20px;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  background: #eee;\n  border-radius: 5px;\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n          margin-right: ",
        ";\n        "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n\n    & + label {\n      cursor: pointer;\n      line-height: 0;\n\n      &:not(:last-of-type) {\n        margin-right: ",
        ";\n\n        ",
        "\n      }\n    }\n\n    &:checked + label {\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n    }\n\n    &.focus-visible + label {\n      ",
        ",\n      ",
        ",\n    ",
        ",\n    ",
        ",\n    ",
        " {\n        box-shadow: 0 0 0 2px ",
        ";\n      }\n    }\n\n    &:disabled + label {\n      cursor: not-allowed;\n    }\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n        width: ",
        "px;\n        height: ",
        "px;\n      "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n          right: 0;\n          left: unset;\n          transform: translateX(0);\n          text-align: right;\n        "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n          left: 0;\n          transform: translateX(0);\n          text-align: left;\n        "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n        width: ",
        "px;\n        height: ",
        "px;\n      "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n\n    & + label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      width: ",
        "px;\n      height: ",
        "px;\n      background: ",
        ";\n      z-index: 2;\n      border-radius: ",
        "px;\n      border: 1px solid\n        ",
        ";\n\n      ",
        ";\n\n      position: relative;\n\n      &::after {\n        content: attr(data-label);\n        position: absolute;\n        align-self: center;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n        margin-top: ",
        ";\n        color: ",
        ";\n        width: 100px;\n        font-size: ",
        ";\n        text-align: center;\n        white-space: nowrap;\n\n        ",
        ";\n\n        ",
        ";\n      }\n    }\n\n    &:checked + label > ",
        " {\n      width: ",
        "px;\n      height: ",
        "px;\n      background: ",
        ";\n      border-radius: 50%;\n\n      ",
        ";\n    }\n\n    &.focus-visible + label {\n      border: 2px solid ",
        ";\n    }\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n            padding: ",
        " ",
        ";\n          "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        ";\n\n        & + label {\n          cursor: pointer;\n          padding: ",
        "\n            ",
        ";\n          border-radius: 5px;\n          white-space: nowrap;\n          user-select: none;\n\n          ",
        ";\n        }\n\n        &:checked + label {\n          background: #fff;\n        }\n\n        &.focus-visible + label {\n          box-shadow: 0 0 0 2px ",
        ";\n        }\n      "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        ";\n\n        & + label {\n          cursor: pointer;\n          margin-right: ",
        ";\n          padding: ",
        ";\n          min-width: 60px;\n          text-align: center;\n          border: 1px solid\n            ",
        ";\n          border-radius: 8px;\n          white-space: nowrap;\n          user-select: none;\n          background: #fff;\n        }\n\n        &:checked + label {\n          padding: calc(",
        " - 1px);\n          border-width: 2px;\n          border-color: ",
        ";\n        }\n      "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        ";\n  margin-top: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}




var CHECKBOX_SIZE = {
    DESKTOP: 18,
    MOBILE: 18
};
var disabledInputStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
var Inputs = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Inputs",
    componentId: "sc-0-0"
})(_templateObject1());
var RadioDot = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "RadioDot",
    componentId: "sc-0-1"
})(_templateObject2());
var MultiRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MultiRadio",
    componentId: "sc-0-2"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9(), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.rate */ .tr.rate && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3()), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.scale */ .tr.scale && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), p.hasSelected ? "80px" : "60px", src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject4(), p.hasSelected ? "90px" : "70px"), Inputs, CHECKBOX_SIZE.DESKTOP / 2, p.showError ? p.theme.text.negative : p.theme.lines.tertiary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject5(), CHECKBOX_SIZE.MOBILE / 2)), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.boolean */ .tr.boolean && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), p.showError ? "0 0 0 1px ".concat(p.theme.text.negative) : "none"), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.booleanV2 */ .tr.booleanV2 && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8()));
});
var SelectedRating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "SelectedRating",
    componentId: "sc-0-3"
})(function(param) {
    var color = param.color, theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, theme.ratings[color].bg, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, theme.ratings[color].fg);
});
var Selected = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Selected",
    componentId: "sc-0-4"
})(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var iconStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject12(), function(p) {
    return p.showError ? "0 0 0 1px ".concat(p.theme.text.negative) : 0;
});
var EmoticonAngryIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonAngry */ .Sd).withConfig({
    displayName: "EmoticonAngryIcon",
    componentId: "sc-0-5"
})(_templateObject13(), iconStyling);
var EmoticonDissatisfiedIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonDissatisfied */ ._z).withConfig({
    displayName: "EmoticonDissatisfiedIcon",
    componentId: "sc-0-6"
})(_templateObject14(), iconStyling);
var EmoticonNeutralIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonNeutral */ .sS).withConfig({
    displayName: "EmoticonNeutralIcon",
    componentId: "sc-0-7"
})(_templateObject15(), iconStyling);
var EmoticonSmilingIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonSmiling */ .wr).withConfig({
    displayName: "EmoticonSmilingIcon",
    componentId: "sc-0-8"
})(_templateObject16(), iconStyling);
var EmoticonLaughingIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonLaughing */ .X3).withConfig({
    displayName: "EmoticonLaughingIcon",
    componentId: "sc-0-9"
})(_templateObject17(), iconStyling);
var RadioRating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "RadioRating",
    componentId: "sc-0-10"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), disabledInputStyles, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, props.$size === "small" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject18(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), EmoticonAngryIcon, props.theme.ratings.negative.bg, EmoticonDissatisfiedIcon, props.theme.ratings.negative.bg, EmoticonNeutralIcon, props.theme.ratings.neutral.bg, EmoticonSmilingIcon, props.theme.ratings.positive.bg, EmoticonLaughingIcon, props.theme.ratings.positive.bg, EmoticonAngryIcon, EmoticonDissatisfiedIcon, EmoticonNeutralIcon, EmoticonSmilingIcon, EmoticonLaughingIcon, props.theme.icons.callToAction);
});
var ScaleRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "ScaleRadio",
    componentId: "sc-0-11"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject24(), disabledInputStyles, CHECKBOX_SIZE.DESKTOP, CHECKBOX_SIZE.DESKTOP, p.theme.bg.primary, CHECKBOX_SIZE.DESKTOP, p.showError ? p.theme.text.negative : p.theme.lines.quaternary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject20(), CHECKBOX_SIZE.MOBILE, CHECKBOX_SIZE.MOBILE), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.theme.text.secondary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, p.alignRight && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject21()), p.alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject22()), RadioDot, CHECKBOX_SIZE.DESKTOP - 6, CHECKBOX_SIZE.DESKTOP - 6, p.theme.lines.highlight, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject23(), CHECKBOX_SIZE.MOBILE - 6, CHECKBOX_SIZE.MOBILE - 6), p.theme.icons.callToAction);
});
var BooleanRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "BooleanRadio",
    componentId: "sc-0-12"
})(function(p) {
    return p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.boolean */ .tr.boolean ? (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject26(), disabledInputStyles, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject25(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150), p.theme.icons.callToAction) : (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject27(), disabledInputStyles, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(p.theme.colors.base800, "0.12"), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, p.theme.colors.maybeBlue500);
});
var Error = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Error",
    componentId: "sc-0-13"
})(_templateObject28(), function(p) {
    return p.background ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100 : 0;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.text.negative;
}, function(p) {
    return p.background ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(p.theme.text.negative, "0.1") : "none";
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 37118:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ shutdown_message_modal)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(10422);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/modal/index.tsx
var modal = __webpack_require__(58203);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71309);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/shutdown-message/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-left: auto;\n  margin-right: auto;\n  width: 25%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledPrimaryButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "StyledPrimaryButton",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/components/shutdown-message/modal.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function modal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function modal_templateObject() {
    var data = modal_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 18px;\n  text-align: center;\n  padding: 16px 0;\n"
    ]);
    modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-0"
})(modal_templateObject());
// Since shutting down PriceSpy.ie, we are redirecing all that traffic to PriceSpy.co.uk
// and we want to show a notification for that traffic as to why they have been redirected.
var ShutdownMessageModal = function(props) {
    var redirectedFromMarket = props.redirectedFromMarket;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(true), 2), isVisible = ref[0], setVisibility = ref[1];
    if ( false || !isVisible) return null;
    var rootElement = document.getElementById("root-modal");
    var closeModal = function() {
        setVisibility(false);
    };
    var message = t("common", // @ts-expect-error -- Types too loose
    "shutdown.redirect-message-".concat(redirectedFromMarket));
    return rootElement ? /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ react.createElement(modal/* default */.Z, {
        width: 500,
        isOpen: true,
        onRequestClose: closeModal
    }, /*#__PURE__*/ react.createElement(Content, null, message, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledPrimaryButton, {
        onClick: closeModal
    }, "Okay")))), rootElement) : null;
};
/* harmony default export */ const shutdown_message_modal = (ShutdownMessageModal);


/***/ }),

/***/ 13834:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": () => (/* binding */ usePersonalizedQuery)
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95939);
/* harmony import */ var src_areas_user_storage_personalization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55964);
/* harmony import */ var _use_gql_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63113);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



function usePersonalizedQuery(options) {
    var ref, ref1, ref2, ref3;
    var queryKey = options.queryKey, query = options.query;
    var user = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.areas.user;
    });
    var variables = _objectSpreadProps(_objectSpread({}, options.variables), {
        pulseEnvironmentId: user === null || user === void 0 ? void 0 : (ref = user.personalization) === null || ref === void 0 ? void 0 : ref.pulseEnvironmentId,
        personalizationClientId: user === null || user === void 0 ? void 0 : (ref1 = user.personalization) === null || ref1 === void 0 ? void 0 : ref1.clientId,
        personalizationExcludeCategories: (0,src_areas_user_storage_personalization__WEBPACK_IMPORTED_MODULE_1__/* .readPersonalizationSettings */ .S)().notInterestedIn.categories.map(function(category) {
            return +category.id;
        })
    });
    return (0,_use_gql_query__WEBPACK_IMPORTED_MODULE_2__/* .useGqlQuery */ .n)({
        query: query,
        queryKey: queryKey.concat([
            variables
        ]),
        enabled: !!(user === null || user === void 0 ? void 0 : (ref2 = user.personalization) === null || ref2 === void 0 ? void 0 : ref2.clientId) && !!(user === null || user === void 0 ? void 0 : (ref3 = user.personalization) === null || ref3 === void 0 ? void 0 : ref3.pulseEnvironmentId),
        variables: variables
    });
}


/***/ }),

/***/ 54817:
/***/ (function(module) {

/*
 * Swipe 2.0.0
 * Brad Birdsall
 * https://github.com/thebird/Swipe
 * Copyright 2013-2015, MIT License
 *
 */

(function(root, factory) {
  if ( true && module.exports) {
    module.exports = factory();
  } else {
    root.Swipe = factory();
  }
})(this, function() {
  'use strict';

  return function Swipe(container, options) {
    // utilities
    var noop = function() {}; // simple no operation function
    var offloadFn = function(fn) {
      setTimeout(fn || noop, 0);
    }; // offload a functions execution

    // check browser capabilities
    var browser = {
      addEventListener: !!window.addEventListener,
      touch:
        'ontouchstart' in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch),
      transitions: (function(temp) {
        var props = [
          'transitionProperty',
          'WebkitTransition',
          'MozTransition',
          'OTransition',
          'msTransition'
        ];
        for (var i in props)
          if (temp.style[props[i]] !== undefined) return true;
        return false;
      })(document.createElement('swipe'))
    };

    // quit if no root element
    if (!container) return;
    var element = container.children[0];
    var slides, slidePos, width, length;
    options = options || {};
    var index = parseInt(options.startSlide, 10) || 0;
    var speed = options.speed || 300;
    var widthOfSiblingSlidePreview =
      parseInt(options.widthOfSiblingSlidePreview, 10) || 0;
    var continuous = (options.continuous =
      options.continuous !== undefined ? options.continuous : true);

    function setup() {
      // cache slides
      slides = element.children;
      length = slides.length;

      // set continuous to false if only one slide
      continuous = slides.length < 2 ? false : options.continuous;

      // create an array to store current positions of each slide
      slidePos = new Array(slides.length);

      // determine width of each slide
      width =
        Math.round(
          container.getBoundingClientRect().width || container.offsetWidth
        ) -
        widthOfSiblingSlidePreview * 2;

      element.style.width = slides.length * width + 'px';

      // stack elements
      var pos = slides.length;
      while (pos--) {
        var slide = slides[pos];

        slide.style.width = width + 'px';
        slide.setAttribute('data-index', pos);

        if (browser.transitions) {
          slide.style.left = pos * -width + widthOfSiblingSlidePreview + 'px';
          move(pos, index > pos ? -width : index < pos ? width : 0, 0);
        }
      }

      // reposition elements before and after index
      if (continuous && browser.transitions) {
        move(circle(index - 1), -width, 0);
        move(circle(index + 1), width, 0);
      }

      if (!browser.transitions)
        element.style.left = index * -width + widthOfSiblingSlidePreview + 'px';

      container.style.visibility = 'visible';
    }

    function prev() {
      if (continuous) slide(index - 1);
      else if (index) slide(index - 1);
    }

    function next() {
      if (continuous) slide(index + 1);
      else if (index < slides.length - 1) slide(index + 1);
    }

    function circle(index) {
      // a simple positive modulo using slides.length
      return (slides.length + (index % slides.length)) % slides.length;
    }

    function slide(to, slideSpeed) {
      // do nothing if already on requested slide
      if (index == to) return;

      if (browser.transitions) {
        var direction = Math.abs(index - to) / (index - to); // 1: backward, -1: forward

        // get the actual position of the slide
        if (continuous) {
          var natural_direction = direction;
          direction = -slidePos[circle(to)] / width;

          // if going forward but to < index, use to = slides.length + to
          // if going backward but to > index, use to = -slides.length + to
          if (direction !== natural_direction)
            to = -direction * slides.length + to;
        }

        var diff = Math.abs(index - to) - 1;

        // move all the slides between index and to in the right direction
        while (diff--)
          move(
            circle((to > index ? to : index) - diff - 1),
            width * direction,
            0
          );

        to = circle(to);

        move(index, width * direction, slideSpeed || speed);
        move(to, 0, slideSpeed || speed);

        if (continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place
      } else {
        to = circle(to);
        animate(index * -width, to * -width, slideSpeed || speed);
        //no fallback for a circular continuous if the browser does not accept transitions
      }

      index = to;
      offloadFn(options.callback && options.callback(index, slides[index]));
    }

    function move(index, dist, speed) {
      translate(index, dist, speed);
      slidePos[index] = dist;
    }

    function translate(index, dist, speed) {
      var slide = slides[index];
      var style = slide && slide.style;

      if (!style) return;

      style.webkitTransitionDuration = style.MozTransitionDuration = style.msTransitionDuration = style.OTransitionDuration = style.transitionDuration =
        speed + 'ms';

      style.webkitTransform = 'translate(' + dist + 'px,0)' + 'translateZ(0)';
      style.msTransform = style.MozTransform = style.OTransform =
        'translateX(' + dist + 'px)';
    }

    function animate(from, to, speed) {
      // if not an animation, just reposition
      if (!speed) {
        element.style.left = to + 'px';
        return;
      }

      var start = +new Date();

      var timer = setInterval(function() {
        var timeElap = +new Date() - start;

        if (timeElap > speed) {
          element.style.left = to + 'px';

          if (delay) begin();

          options.transitionEnd &&
            options.transitionEnd.call(event, index, slides[index]);

          clearInterval(timer);
          return;
        }

        element.style.left =
          (to - from) * (Math.floor((timeElap / speed) * 100) / 100) +
          from +
          'px';
      }, 4);
    }

    // setup auto slideshow
    var delay = options.auto || 0;
    var interval;

    function begin() {
      clearTimeout(interval);
      interval = setTimeout(next, delay);
    }

    function stop() {
      delay = 0;
      clearTimeout(interval);
    }

    // setup initial vars
    var start = {};
    var delta = {};
    var isScrolling;

    // setup event capturing
    var events = {
      handleEvent: function(event) {
        switch (event.type) {
          case 'touchstart':
            this.start(event);
            break;
          case 'touchmove':
            this.move(event);
            break;
          case 'touchend':
            offloadFn(this.end(event));
            break;
          case 'webkitTransitionEnd':
          case 'msTransitionEnd':
          case 'oTransitionEnd':
          case 'otransitionend':
          case 'transitionend':
            offloadFn(this.transitionEnd(event));
            break;
          case 'resize':
            offloadFn(setup);
            break;
        }

        if (options.stopPropagation) event.stopPropagation();
      },
      start: function(event) {
        var touches = event.touches[0];

        // measure start values
        start = {
          // get initial touch coords
          x: touches.pageX,
          y: touches.pageY,

          // store time to determine touch duration
          time: +new Date()
        };

        // used for testing first move event
        isScrolling = undefined;

        // reset delta and end measurements
        delta = {};

        // attach touchmove and touchend listeners
        element.addEventListener('touchmove', this, false);
        element.addEventListener('touchend', this, false);
      },
      move: function(event) {
        // ensure swiping with one touch and not pinching
        if (event.touches.length > 1 || (event.scale && event.scale !== 1))
          return;

        if (options.disableScroll) return;

        var touches = event.touches[0];

        // measure change in x and y
        delta = {
          x: touches.pageX - start.x,
          y: touches.pageY - start.y
        };

        // determine if scrolling test has run - one time test
        if (typeof isScrolling == 'undefined') {
          isScrolling = !!(
            isScrolling || Math.abs(delta.x) < Math.abs(delta.y)
          );
        }

        // if user is not trying to scroll vertically
        if (!isScrolling) {
          // prevent native scrolling
          event.preventDefault();

          // stop slideshow
          stop();

          // increase resistance if first or last slide
          if (continuous) {
            // we don't add resistance at the end

            translate(
              circle(index - 1),
              delta.x + slidePos[circle(index - 1)],
              0
            );
            translate(index, delta.x + slidePos[index], 0);
            translate(
              circle(index + 1),
              delta.x + slidePos[circle(index + 1)],
              0
            );
          } else {
            delta.x =
              delta.x /
              ((!index && delta.x > 0) || // if first slide and sliding left
              (index == slides.length - 1 && // or if last slide and sliding right
                delta.x < 0) // and if sliding at all
                ? Math.abs(delta.x) / width + 1 // determine resistance level
                : 1); // no resistance if false

            // translate 1:1
            translate(index - 1, delta.x + slidePos[index - 1], 0);
            translate(index, delta.x + slidePos[index], 0);
            translate(index + 1, delta.x + slidePos[index + 1], 0);
          }
          options.swiping && options.swiping(-delta.x / width);
        }
      },
      end: function(event) {
        // measure duration
        var duration = +new Date() - start.time;

        // determine if slide attempt triggers next/prev slide
        var isValidSlide =
          (Number(duration) < 250 && // if slide duration is less than 250ms
            Math.abs(delta.x) > 20) || // and if slide amt is greater than 20px
          Math.abs(delta.x) > width / 2; // or if slide amt is greater than half the width

        // determine if slide attempt is past start and end
        var isPastBounds =
          (!index && delta.x > 0) || // if first slide and slide amt is greater than 0
          (index == slides.length - 1 && delta.x < 0); // or if last slide and slide amt is less than 0

        if (continuous) isPastBounds = false;

        // determine direction of swipe (true:right, false:left)
        var direction = delta.x < 0;

        // if not scrolling vertically
        if (!isScrolling) {
          if (isValidSlide && !isPastBounds) {
            if (direction) {
              if (continuous) {
                // we need to get the next in this direction in place

                move(circle(index - 1), -width, 0);
                move(circle(index + 2), width, 0);
              } else {
                move(index - 1, -width, 0);
              }

              move(index, slidePos[index] - width, speed);
              move(
                circle(index + 1),
                slidePos[circle(index + 1)] - width,
                speed
              );
              index = circle(index + 1);
            } else {
              if (continuous) {
                // we need to get the next in this direction in place

                move(circle(index + 1), width, 0);
                move(circle(index - 2), -width, 0);
              } else {
                move(index + 1, width, 0);
              }

              move(index, slidePos[index] + width, speed);
              move(
                circle(index - 1),
                slidePos[circle(index - 1)] + width,
                speed
              );
              index = circle(index - 1);
            }

            options.callback && options.callback(index, slides[index]);
          } else {
            if (continuous) {
              move(circle(index - 1), -width, speed);
              move(index, 0, speed);
              move(circle(index + 1), width, speed);
            } else {
              move(index - 1, -width, speed);
              move(index, 0, speed);
              move(index + 1, width, speed);
            }
          }
        }

        // kill touchmove and touchend event listeners until touchstart called again
        element.removeEventListener('touchmove', events, false);
        element.removeEventListener('touchend', events, false);
        element.removeEventListener('touchforcechange', function() {}, false);
      },
      transitionEnd: function(event) {
        if (parseInt(event.target.getAttribute('data-index'), 10) == index) {
          if (delay) begin();

          options.transitionEnd &&
            options.transitionEnd.call(event, index, slides[index]);
        }
      }
    };

    // trigger setup
    setup();

    // start auto slideshow if applicable
    if (delay) begin();

    // add event listeners
    if (browser.addEventListener) {
      // set touchstart event on element
      if (browser.touch) {
        element.addEventListener('touchstart', events, false);
        element.addEventListener('touchforcechange', function() {}, false);
      }

      if (browser.transitions) {
        element.addEventListener('webkitTransitionEnd', events, false);
        element.addEventListener('msTransitionEnd', events, false);
        element.addEventListener('oTransitionEnd', events, false);
        element.addEventListener('otransitionend', events, false);
        element.addEventListener('transitionend', events, false);
      }

      // set resize event on window
      window.addEventListener('resize', events, false);
    } else {
      window.onresize = function() {
        setup();
      }; // to play nice with old IE
    }

    // expose the Swipe API
    return {
      setup: function() {
        setup();
      },
      slide: function(to, speed) {
        // cancel slideshow
        stop();

        slide(to, speed);
      },
      prev: function() {
        // cancel slideshow
        stop();

        prev();
      },
      next: function() {
        // cancel slideshow
        stop();

        next();
      },
      stop: function() {
        // cancel slideshow
        stop();
      },
      getPos: function() {
        // return current index position
        return index;
      },
      getNumSlides: function() {
        // return total number of slides
        return length;
      },
      kill: function() {
        // cancel slideshow
        stop();

        // reset element
        element.style.width = '';
        element.style.left = '';

        // reset slides
        var pos = slides.length;
        while (pos--) {
          var slide = slides[pos];
          slide.style.width = '';
          slide.style.left = '';

          if (browser.transitions) translate(pos, 0, 0);
        }

        // removed event listeners
        if (browser.addEventListener) {
          // remove current event listeners
          element.removeEventListener('touchstart', events, false);
          element.removeEventListener('webkitTransitionEnd', events, false);
          element.removeEventListener('msTransitionEnd', events, false);
          element.removeEventListener('oTransitionEnd', events, false);
          element.removeEventListener('otransitionend', events, false);
          element.removeEventListener('transitionend', events, false);
          window.removeEventListener('resize', events, false);
        } else {
          window.onresize = null;
        }
      }
    };
  };
});


/***/ }),

/***/ 57070:
/***/ ((module) => {

module.exports = "query productAlertForm($id: Int!) {\n  product(id: $id) {\n    id\n    name\n    stockStatus\n    media {\n      first(width: _280)\n    }\n    pathName\n    userReviewSummary {\n      count\n      rating\n    }\n    aggregatedRatingSummary {\n      summary {\n        rating {\n          score\n          count\n        }\n      }\n    }\n    prices {\n      nodes {\n        store {\n          userReviewSummary {\n            rating\n            count\n          }\n        }\n      }\n    }\n    priceSummary {\n      regular\n    }\n    alert {\n      id\n      priceThreshold\n      alertType\n      priceStep\n      storePreference\n      storeGradeThreshold\n    }\n  }\n}"

/***/ }),

/***/ 57053:
/***/ ((module) => {

module.exports = "query recommendationsQuery($id: Int!, $recommendationsContextId: String, $personalizationClientId: String, $marketCode: String) {\n  ...recommendations\n}\n\nfragment recommendations on RootQuery {\n  recommendations(\n    clientId: $personalizationClientId\n    marketCode: $marketCode\n    contextId: $recommendationsContextId\n    productId: $id\n  ) {\n    model\n    recommendations(onlyFromFeaturedStores: true) {\n      score\n      product {\n        id\n        name\n        pathName: semanticId\n        brand {\n          id\n          name\n        }\n        price {\n          regular\n        }\n        media {\n          first\n        }\n        uri\n        webUri\n        userReviews {\n          rating\n          count\n        }\n        aggregatedRating {\n          score\n          count\n        }\n        category {\n          name\n        }\n        isExpertTopRated\n      }\n    }\n    personalized\n    version\n  }\n}"

/***/ })

}]);